/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "analyticsv2/reportbuilder/models.proto" (package "rd.analyticsv2.reportbuilder", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../google/protobuf/timestamp_pb";
import { User } from "../../user/models_pb";
import { SortOrder } from "../models_pb";
import { TimestampRange } from "../../proto/timestamprange/models_pb";
import { UUID } from "../../proto/uuid/models_pb";
import { FractionalMoney } from "../../proto/money/models_pb";
import { Money } from "../../proto/money/models_pb";
import { Decimal } from "../../proto/decimal/models_pb";
/**
 * @generated from protobuf message rd.analyticsv2.reportbuilder.Report
 */
export interface Report {
    /**
     * @generated from protobuf field: string title = 1
     */
    title: string;
    /**
     * @generated from protobuf field: string subtitle = 2
     */
    subtitle: string;
    /**
     * @generated from protobuf field: repeated rd.analyticsv2.reportbuilder.Report.Series series = 3
     */
    series: Report_Series[];
    /**
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.Report.Table table = 4
     */
    table?: Report_Table;
    /**
     * ReportBuilderUrl contains a relative URL encoding the parameters that this
     * report was produced with. TimestampRanges are resolved to absolute ranges
     * in this encoding.
     *
     * @generated from protobuf field: string report_builder_url = 5
     */
    reportBuilderUrl: string;
}
/**
 * Series returns report data in a form suitable for displaying a chart. Each
 * series is intended to be shown as a separate line or bar chart.
 *
 * @generated from protobuf message rd.analyticsv2.reportbuilder.Report.Series
 */
export interface Report_Series {
    /**
     * Type indicates whether the data points are time-based or ordinal.
     *
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.Report.Series.Type type = 1
     */
    type: Report_Series_Type;
    /**
     * @generated from protobuf field: string label = 2
     */
    label: string;
    /**
     * @generated from protobuf field: repeated rd.analyticsv2.reportbuilder.Report.Series.Point points = 3
     */
    points: Report_Series_Point[];
    /**
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.Report.Series.Unit unit = 4
     */
    unit: Report_Series_Unit;
    /**
     * note that groups separate points and subgroups separate series
     *
     * @generated from protobuf field: repeated string subgroups = 5
     */
    subgroups: string[];
}
/**
 * @generated from protobuf message rd.analyticsv2.reportbuilder.Report.Series.Point
 */
export interface Report_Series_Point {
    /**
     * @generated from protobuf field: string label = 1
     */
    label: string; // categorical string or rfc3339 timestamp: "2024-01-02T03:45:56Z"
    /**
     * @generated from protobuf field: float value = 2
     */
    value: number;
    /**
     * note that groups separate points and subgroups separate series
     *
     * @generated from protobuf field: repeated string groups = 3
     */
    groups: string[];
}
/**
 * @generated from protobuf enum rd.analyticsv2.reportbuilder.Report.Series.Type
 */
export enum Report_Series_Type {
    /**
     * @generated from protobuf enum value: TYPE_SCALAR = 0;
     */
    SCALAR = 0,
    /**
     * @generated from protobuf enum value: TYPE_TIMESERIES = 1;
     */
    TIMESERIES = 1
}
/**
 * Unit indicates whether point values are money or untyped scalar for formatting purposes.
 *
 * @generated from protobuf enum rd.analyticsv2.reportbuilder.Report.Series.Unit
 */
export enum Report_Series_Unit {
    /**
     * @generated from protobuf enum value: UNIT_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: UNIT_SCALAR = 1;
     */
    SCALAR = 1,
    /**
     * @generated from protobuf enum value: UNIT_MONEY = 2;
     */
    MONEY = 2
}
/**
 * Table is a tabular representation of the report data. Different group and
 * subgroup keys will yield separate rows in the table. If `gen_xy_table` was
 * enabled, then different subgroup keys appear as separate table columns.
 *
 * @generated from protobuf message rd.analyticsv2.reportbuilder.Report.Table
 */
export interface Report_Table {
    /**
     * @generated from protobuf field: repeated string headers = 1
     */
    headers: string[];
    /**
     * @generated from protobuf field: repeated rd.analyticsv2.reportbuilder.Report.Table.Row rows = 2
     */
    rows: Report_Table_Row[];
    /**
     * Summary contains the summarized values of each column.
     *
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.Report.Table.Row summary = 3
     */
    summary?: Report_Table_Row;
    /**
     * @generated from protobuf field: repeated rd.analyticsv2.reportbuilder.Report.Table.Header headers_v2 = 4
     */
    headersV2: Report_Table_Header[];
    /**
     * TotalRows is the total number of rows in the original untruncated table.
     *
     * @generated from protobuf field: int32 total_rows = 5
     */
    totalRows: number;
}
/**
 * Cell is a typed cell value. "Root" columns (e.g. GROUPV2_CUSTOMER,
 * GROUPV2_PRODUCT) will include a string representation of their UUID in
 * their Metadata.
 *
 * @generated from protobuf message rd.analyticsv2.reportbuilder.Report.Table.Cell
 */
export interface Report_Table_Cell {
    /**
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.Report.Table.Cell.Type type = 1
     */
    type: Report_Table_Cell_Type;
    /**
     * @generated from protobuf field: string string_val = 2
     */
    stringVal: string;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal decimal_val = 3
     */
    decimalVal?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.money.Money money_val = 4
     */
    moneyVal?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.FractionalMoney fractional_money_val = 5
     */
    fractionalMoneyVal?: FractionalMoney;
    /**
     * @generated from protobuf field: int64 int_val = 6
     */
    intVal: bigint;
    /**
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.Report.Table.Cell.Metadata metadata = 7
     */
    metadata?: Report_Table_Cell_Metadata;
}
/**
 * @generated from protobuf message rd.analyticsv2.reportbuilder.Report.Table.Cell.Metadata
 */
export interface Report_Table_Cell_Metadata {
    /**
     * @generated from protobuf field: repeated rd.analyticsv2.reportbuilder.Filter filters = 1
     */
    filters: Filter[];
}
/**
 * @generated from protobuf enum rd.analyticsv2.reportbuilder.Report.Table.Cell.Type
 */
export enum Report_Table_Cell_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: TYPE_STRING = 1;
     */
    STRING = 1,
    /**
     * @generated from protobuf enum value: TYPE_DECIMAL = 2;
     */
    DECIMAL = 2,
    /**
     * @generated from protobuf enum value: TYPE_MONEY = 3;
     */
    MONEY = 3,
    /**
     * @generated from protobuf enum value: TYPE_FRACTIONAL_MONEY = 4;
     */
    FRACTIONAL_MONEY = 4,
    /**
     * @generated from protobuf enum value: TYPE_INT = 5;
     */
    INT = 5,
    /**
     * @generated from protobuf enum value: TYPE_PERCENT = 6;
     */
    PERCENT = 6,
    /**
     * @generated from protobuf enum value: TYPE_DATE = 7;
     */
    DATE = 7,
    /**
     * @generated from protobuf enum value: TYPE_BOOL = 8;
     */
    BOOL = 8,
    /**
     * @generated from protobuf enum value: TYPE_LIST = 9;
     */
    LIST = 9
}
/**
 * @generated from protobuf message rd.analyticsv2.reportbuilder.Report.Table.Row
 */
export interface Report_Table_Row {
    /**
     * @generated from protobuf field: repeated string cells = 1
     */
    cells: string[];
    /**
     * @generated from protobuf field: repeated rd.analyticsv2.reportbuilder.Report.Table.Cell cells_v2 = 2
     */
    cellsV2: Report_Table_Cell[];
}
/**
 * @generated from protobuf message rd.analyticsv2.reportbuilder.Report.Table.Header
 */
export interface Report_Table_Header {
    /**
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * @generated from protobuf field: repeated string subgroup_values = 2
     */
    subgroupValues: string[];
    /**
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.ReportParamsV2.Column original_column = 3
     */
    originalColumn?: ReportParamsV2_Column;
    /**
     * @generated from protobuf field: repeated rd.analyticsv2.reportbuilder.Aggregation allowed_aggregations = 4
     */
    allowedAggregations: Aggregation[];
    /**
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.Report.Table.Cell.Type cell_type = 5
     */
    cellType: Report_Table_Cell_Type;
    /**
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.Report.Table.Header.ComparisonColumnInfo comparison_info = 6
     */
    comparisonInfo?: Report_Table_Header_ComparisonColumnInfo;
    /**
     * @generated from protobuf field: string comparison_name_suffix = 8
     */
    comparisonNameSuffix: string;
    /**
     * @generated from protobuf field: string description = 9
     */
    description: string;
    /**
     * default_aggregation is the aggregation that DEFAULT resolves to for this column.
     * Unset (DEFAULT) when original_column.aggregation is explicitly set by the user.
     *
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.Aggregation default_aggregation = 10
     */
    defaultAggregation: Aggregation;
}
/**
 * ComparisonColumnInfo stores relative offsets from a comparison column to its dependencies.
 * Used for percent change and delta difference columns.
 * TODO: Could optionally remove offsets and use column keys in mobile
 *
 * @generated from protobuf message rd.analyticsv2.reportbuilder.Report.Table.Header.ComparisonColumnInfo
 */
export interface Report_Table_Header_ComparisonColumnInfo {
    /**
     * @generated from protobuf field: int32 base_column_offset = 1
     */
    baseColumnOffset: number;
    /**
     * @generated from protobuf field: int32 compare_column_offset = 2
     */
    compareColumnOffset: number;
    /**
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.ReportParamsV2.DateCompareColumnKey dc_key = 3
     */
    dcKey?: ReportParamsV2_DateCompareColumnKey;
}
/**
 * Filters allow restricting the data set to records matching the target fields
 * by ID or Enum value. filters for different attributes are ANDed, and filters
 * for the same attribute are ORed.
 *
 * @generated from protobuf message rd.analyticsv2.reportbuilder.Filter
 */
export interface Filter {
    /**
     * Attribute defines which field to filter by
     *
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.Filter.Attribute attribute = 1
     */
    attribute: Filter_Attribute;
    /**
     * Id is the value to filter by. The id's bytes are the raw (not
     * human-readable) 16 uuid bytes.
     *
     * @generated from protobuf field: rd.proto.uuid.UUID id = 2
     */
    id?: UUID;
    /**
     * integer enum value
     *
     * @generated from protobuf field: int32 enum_val = 3
     */
    enumVal: number;
    /**
     * label is the human-readable name of the filter
     *
     * @generated from protobuf field: string label = 4
     */
    label: string;
    /**
     * boolean value
     *
     * @generated from protobuf field: bool bool_val = 5
     */
    boolVal: boolean;
    /**
     * to be used for string ids that are not uuids
     *
     * @generated from protobuf field: string string_id = 6
     */
    stringId: string;
    /**
     * timestamp window for DATE RANGE attribute filters (attribute >= 40_000)
     *
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange date_range = 7
     */
    dateRange?: TimestampRange;
}
/**
 * @generated from protobuf enum rd.analyticsv2.reportbuilder.Filter.Attribute
 */
export enum Filter_Attribute {
    /**
     * ID attribute filters: anything with number < 10000
     *
     * @generated from protobuf enum value: ATTRIBUTE_LOCATION_ID = 0;
     */
    LOCATION_ID = 0,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_CUSTOMER_ID = 1;
     */
    CUSTOMER_ID = 1,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_PRODUCT_ID = 2;
     */
    PRODUCT_ID = 2,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_PRODUCT_CATEGORY_ID = 3;
     */
    PRODUCT_CATEGORY_ID = 3,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_CLERK_ID = 4;
     */
    CLERK_ID = 4,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_REP_ID = 5;
     */
    REP_ID = 5,
    /**
     * legacy - for backward compat with old report metadata
     *
     * @generated from protobuf enum value: ATTRIBUTE_TAG_ID = 6;
     */
    TAG_ID = 6,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_VENDOR_ID = 7;
     */
    VENDOR_ID = 7,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_TRANSFER_ID = 8;
     */
    TRANSFER_ID = 8,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_SALE_ID = 9;
     */
    SALE_ID = 9,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_METHOD_ID = 10;
     */
    METHOD_ID = 10,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_PAYMENT_ID = 11;
     */
    PAYMENT_ID = 11,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_FINANCE_CHARGE_ID = 12;
     */
    FINANCE_CHARGE_ID = 12,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_CUSTOMER_TAG_ID = 13;
     */
    CUSTOMER_TAG_ID = 13,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_PRODUCT_TAG_ID = 14;
     */
    PRODUCT_TAG_ID = 14,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_PRICE_RULE_ID = 15;
     */
    PRICE_RULE_ID = 15,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_INVENTORY_COUNT_ID = 16;
     */
    INVENTORY_COUNT_ID = 16,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_ORDER_ID = 17;
     */
    ORDER_ID = 17,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_ORIGINAL_SALE_CLERK_ID = 18;
     */
    ORIGINAL_SALE_CLERK_ID = 18,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_GIFT_CARD_ID = 19;
     */
    GIFT_CARD_ID = 19,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_ACCOUNT_ID = 20;
     */
    ACCOUNT_ID = 20,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_ORDER_SHIPMENT_ID = 21;
     */
    ORDER_SHIPMENT_ID = 21,
    /**
     * Polymorphic transaction reference on the Single Entries report. The row
     * emits the UUID of whichever transaction its TxnCell chip points at (sale,
     * bill payment, order, order shipment, transfer, finance charge). A filter
     * with a specific UUID scopes the report to rows tied to that transaction
     * and hides everything else, including rows whose chip points at a
     * different transaction of the same type.
     *
     * @generated from protobuf enum value: ATTRIBUTE_TRANSACTION_ID = 22;
     */
    TRANSACTION_ID = 22,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_PAYOUT_ID = 23;
     */
    PAYOUT_ID = 23,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_ENTITY_ID = 24;
     */
    ENTITY_ID = 24,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_EXTERNAL_TRANSACTION_ID = 25;
     */
    EXTERNAL_TRANSACTION_ID = 25,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_SALE_DESIGNATED_CLERK_ID = 26;
     */
    SALE_DESIGNATED_CLERK_ID = 26,
    /**
     * string ID for Rundoo Banking (FinancialTransaction) entries
     *
     * @generated from protobuf enum value: ATTRIBUTE_INTERNAL_TRANSACTION_ID = 27;
     */
    INTERNAL_TRANSACTION_ID = 27,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_MANUAL_JOURNAL_ENTRY_ID = 28;
     */
    MANUAL_JOURNAL_ENTRY_ID = 28,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_DELIVERY_ID = 29;
     */
    DELIVERY_ID = 29,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_RETURNED_FROM_SALE_ID = 30;
     */
    RETURNED_FROM_SALE_ID = 30,
    /**
     * chip type for single-entry transaction type (uses analytics.Chip_Type int32s,
     * distinct from ATTRIBUTE_TRANSACTION_TYPE which uses TransactionTypeDisplay int32s)
     *
     * @generated from protobuf enum value: ATTRIBUTE_SINGLE_ENTRY_TXN_TYPE = 10012;
     */
    SINGLE_ENTRY_TXN_TYPE = 10012,
    /**
     * ENUM attribute filters: anything with number >=10_000 and number < 20_000
     * ledgerEntry type
     *
     * @generated from protobuf enum value: ATTRIBUTE_TRANSACTION_TYPE = 10000;
     */
    TRANSACTION_TYPE = 10000,
    /**
     * status of an overall count, is it terminal (accepted, voided) or draft?
     *
     * @generated from protobuf enum value: ATTRIBUTE_INVENTORY_COUNT_STATUS = 10001;
     */
    INVENTORY_COUNT_STATUS = 10001,
    /**
     * status of a product within an inventory count
     *
     * @generated from protobuf enum value: ATTRIBUTE_INVENTORY_COUNT_PRODUCT_STATUS = 10002;
     */
    INVENTORY_COUNT_PRODUCT_STATUS = 10002,
    /**
     * status of a sale (draft, will call, special order, received, voided)
     *
     * @generated from protobuf enum value: ATTRIBUTE_SALE_STATUS = 10003;
     */
    SALE_STATUS = 10003,
    /**
     * type of a sale (sale vs return)
     *
     * @generated from protobuf enum value: ATTRIBUTE_SALE_TYPE = 10008;
     */
    SALE_TYPE = 10008,
    /**
     * source of a sale (POS vs e-commerce)
     *
     * @generated from protobuf enum value: ATTRIBUTE_SALE_SOURCE = 10011;
     */
    SALE_SOURCE = 10011,
    /**
     * status of an order shipment
     *
     * @generated from protobuf enum value: ATTRIBUTE_ORDER_SHIPMENT_STATUS = 10004;
     */
    ORDER_SHIPMENT_STATUS = 10004,
    /**
     * payment method for transactions
     *
     * @generated from protobuf enum value: ATTRIBUTE_TENDER_METHOD = 10005;
     */
    TENDER_METHOD = 10005,
    /**
     * status of an order
     *
     * @generated from protobuf enum value: ATTRIBUTE_ORDER_STATUS = 10006;
     */
    ORDER_STATUS = 10006,
    /**
     * status of a transfer
     *
     * @generated from protobuf enum value: ATTRIBUTE_TRANSFER_STATUS = 10007;
     */
    TRANSFER_STATUS = 10007,
    /**
     * type of account
     *
     * @generated from protobuf enum value: ATTRIBUTE_ACCOUNT_TYPE = 10009;
     */
    ACCOUNT_TYPE = 10009,
    /**
     * control account for a single entry
     *
     * @generated from protobuf enum value: ATTRIBUTE_CONTROL_ACCOUNT = 10010;
     */
    CONTROL_ACCOUNT = 10010,
    /**
     * status of a delivery
     *
     * @generated from protobuf enum value: ATTRIBUTE_DELIVERY_STATUS = 10013;
     */
    DELIVERY_STATUS = 10013,
    /**
     * BOOL attribute filters: anything with number >= 20_000 and number < 30_000
     * is customer active (boolean, 0 is false, 1 is true)
     *
     * @generated from protobuf enum value: ATTRIBUTE_CUSTOMER_ACTIVE = 20000;
     */
    CUSTOMER_ACTIVE = 20000,
    /**
     * whether the product is stock or non-stock (which includes special orderable)
     *
     * @generated from protobuf enum value: ATTRIBUTE_IS_STOCK = 20001;
     */
    IS_STOCK = 20001,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_PAYOUT_TXN_TYPE = 20002;
     */
    PAYOUT_TXN_TYPE = 20002,
    /**
     * whether the sale/return has been paid/refunded
     *
     * @generated from protobuf enum value: ATTRIBUTE_IS_PAID = 20005;
     */
    IS_PAID = 20005,
    /**
     * STRING ID attribute filters: anything with number >= 30_000 and < 40_000,
     * for attributes whose ids are strings rather than UUIDs. These carry their
     * value in string_id rather than id
     *
     * @generated from protobuf enum value: ATTRIBUTE_ADDITIONAL_FEE_ID = 30000;
     */
    ADDITIONAL_FEE_ID = 30000,
    /**
     * DATE RANGE attribute filters: anything with number >= 40_000. These carry a
     * timestamp window in date_range and keep rows whose value falls inside it.
     *
     * @generated from protobuf enum value: ATTRIBUTE_PAID_AT = 40000;
     */
    PAID_AT = 40000,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_PRICE_UPDATED_AT = 40001;
     */
    PRICE_UPDATED_AT = 40001,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_PAYOUT_DATE = 40002;
     */
    PAYOUT_DATE = 40002,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_DELIVERY_DEPARTURE_TIME = 40003;
     */
    DELIVERY_DEPARTURE_TIME = 40003
}
/**
 * PredicateFilterKeys can identify date compare columns but do not distinguish between subgrouped
 * columns, as predicate filters are ORed across subgrouped columns.
 *
 * @generated from protobuf message rd.analyticsv2.reportbuilder.PredicateFilterKey
 */
export interface PredicateFilterKey {
    /**
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.GroupV2 group = 1
     */
    group: GroupV2;
    /**
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.Aggregation aggregation = 2
     */
    aggregation: Aggregation;
    /**
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.ReportParamsV2.DateCompareColumnKey dc_key = 3
     */
    dcKey?: ReportParamsV2_DateCompareColumnKey;
}
/**
 * @generated from protobuf message rd.analyticsv2.reportbuilder.PredicateFilter
 */
export interface PredicateFilter {
    /**
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.PredicateFilter.Op op = 3
     */
    op: PredicateFilter_Op;
    /**
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.Report.Table.Cell value = 4
     */
    value?: Report_Table_Cell; // single operand; superseded by values, ignored by unary ops
    /**
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.PredicateFilterKey ColumnKey = 5
     */
    columnKey?: PredicateFilterKey;
    /**
     * Operands for predicate ops
     *
     * @generated from protobuf field: repeated rd.analyticsv2.reportbuilder.Report.Table.Cell values = 6
     */
    values: Report_Table_Cell[];
}
/**
 * @generated from protobuf enum rd.analyticsv2.reportbuilder.PredicateFilter.Op
 */
export enum PredicateFilter_Op {
    /**
     * @generated from protobuf enum value: OP_EQUAL = 0;
     */
    EQUAL = 0,
    /**
     * @generated from protobuf enum value: OP_NOT_EQUAL = 1;
     */
    NOT_EQUAL = 1,
    /**
     * @generated from protobuf enum value: OP_GREATER = 2;
     */
    GREATER = 2,
    /**
     * @generated from protobuf enum value: OP_LESS = 3;
     */
    LESS = 3,
    /**
     * @generated from protobuf enum value: OP_GREATER_EQUAL = 4;
     */
    GREATER_EQUAL = 4,
    /**
     * @generated from protobuf enum value: OP_LESS_EQUAL = 5;
     */
    LESS_EQUAL = 5,
    /**
     * @generated from protobuf enum value: OP_CONTAINS = 6;
     */
    CONTAINS = 6,
    /**
     * @generated from protobuf enum value: OP_NOT_CONTAINS = 7;
     */
    NOT_CONTAINS = 7,
    /**
     * @generated from protobuf enum value: OP_STARTS_WITH = 8;
     */
    STARTS_WITH = 8,
    /**
     * @generated from protobuf enum value: OP_ENDS_WITH = 9;
     */
    ENDS_WITH = 9,
    /**
     * @generated from protobuf enum value: OP_IS_EMPTY = 10;
     */
    IS_EMPTY = 10,
    /**
     * @generated from protobuf enum value: OP_IS_NOT_EMPTY = 11;
     */
    IS_NOT_EMPTY = 11,
    /**
     * @generated from protobuf enum value: OP_CONTAINS_ALL = 12;
     */
    CONTAINS_ALL = 12
}
/**
 * ReportParams define the parameters for a report builder request. They are
 * stored on the frontend to save report configurations, so we should avoid
 * modifying them non-additively.
 *
 * @generated from protobuf message rd.analyticsv2.reportbuilder.ReportParams
 */
export interface ReportParams {
    /**
     * DataSource is the dataset that the report will be based on.
     *
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.DataSource data_source = 1
     */
    dataSource: DataSource;
    /**
     * DataSourceRange is the time range of data to query
     *
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange data_source_range = 2
     */
    dataSourceRange?: TimestampRange;
    /**
     * Groups is the list of fields to group results by. Each unique set of group
     * values will be a separate data point in the output.
     *
     * @generated from protobuf field: repeated rd.analyticsv2.reportbuilder.Group groups = 3
     */
    groups: Group[];
    /**
     * Subgroups allows grouping by a secondary set of fields. Each unique set of
     * subgroup values will be a separate data series. See also `gen_xy_table`.
     *
     * @generated from protobuf field: repeated rd.analyticsv2.reportbuilder.Group subgroups = 4
     */
    subgroups: Group[];
    /**
     * If compare_unit is >0, this enables comparison against past data
     *
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.ReportParams.CompareUnit compare_unit = 5
     */
    compareUnit: ReportParams_CompareUnit;
    /**
     * The amount of `compare_unit` units of time in the past to compare against
     *
     * @generated from protobuf field: int32 compare_amount = 6
     */
    compareAmount: number;
    /**
     * If set, this sorts table output by the given column number
     *
     * @generated from protobuf field: int32 sort_column_index = 7
     */
    sortColumnIndex: number;
    /**
     * @generated from protobuf field: int32 sort_order = 8
     */
    sortOrder: number; // 0:no sort, 1:desc, 2:asc
    /**
     * Filters allow restricting the data set to records matching the target fields by id.
     * filters for different attributes are ANDed, and filters for the same attribute are ORed.
     *
     * @generated from protobuf field: repeated rd.analyticsv2.reportbuilder.ReportParams.Filter filters = 9
     */
    filters: ReportParams_Filter[];
    /**
     * If true, the generated table will have one row per unique set of group
     * keys and one column per unique set of subgroup keys.
     *
     * @generated from protobuf field: bool gen_xy_table = 10
     */
    genXyTable: boolean;
}
/**
 * @generated from protobuf message rd.analyticsv2.reportbuilder.ReportParams.Filter
 */
export interface ReportParams_Filter {
    /**
     * Attribute defines which field to filter by
     *
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.ReportParams.Filter.Attribute attribute = 1
     */
    attribute: ReportParams_Filter_Attribute;
    /**
     * Id is the value to filter by
     *
     * @generated from protobuf field: rd.proto.uuid.UUID id = 2
     */
    id?: UUID;
}
/**
 * @generated from protobuf enum rd.analyticsv2.reportbuilder.ReportParams.Filter.Attribute
 */
export enum ReportParams_Filter_Attribute {
    /**
     * @generated from protobuf enum value: ATTRIBUTE_LOCATION_ID = 0;
     */
    LOCATION_ID = 0,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_CUSTOMER_ID = 1;
     */
    CUSTOMER_ID = 1,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_PRODUCT_ID = 2;
     */
    PRODUCT_ID = 2,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_PRODUCT_CATEGORY_ID = 3;
     */
    PRODUCT_CATEGORY_ID = 3,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_CLERK_ID = 4;
     */
    CLERK_ID = 4,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_REP_ID = 5;
     */
    REP_ID = 5,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_TAG_ID = 6;
     */
    TAG_ID = 6,
    /**
     * @generated from protobuf enum value: ATTRIBUTE_VENDOR_ID = 7;
     */
    VENDOR_ID = 7
}
/**
 * @generated from protobuf enum rd.analyticsv2.reportbuilder.ReportParams.CompareUnit
 */
export enum ReportParams_CompareUnit {
    /**
     * @generated from protobuf enum value: COMPARE_UNIT_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: COMPARE_UNIT_DAY = 1;
     */
    DAY = 1,
    /**
     * @generated from protobuf enum value: COMPARE_UNIT_MONTH = 2;
     */
    MONTH = 2,
    /**
     * @generated from protobuf enum value: COMPARE_UNIT_YEAR = 3;
     */
    YEAR = 3
}
/**
 * ReportParamsV2 define the parameters for a report builder request. This will
 * eventually replace ReportParams.
 *
 * @generated from protobuf message rd.analyticsv2.reportbuilder.ReportParamsV2
 */
export interface ReportParamsV2 {
    /**
     * BaseData is the dataset that the report will be based on. This determines
     * which underlying table the report's rows will be reduced from.
     *
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.BaseData base_data = 1
     */
    baseData: BaseData;
    /**
     * DataSourceRange is the time range of data to query
     *
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange data_source_range = 2
     */
    dataSourceRange?: TimestampRange;
    /**
     * Columns specifies the set of columns to produce in the output table.
     * Column.Group is the value to output in this column. Can be a label or
     * metric. Rows will automatically be grouped by all labels. For example,
     * specifying CUSTOMER, DEPARTMENT, and SOLD_PRODUCT_REVENUE, will output one
     * row per (CUSTOMER,DEPARTMENT) pair and the revenue for each pair.
     * Column.Subgroups allows further breaking down a column with pivot
     * table-like functionality. Not needed for standard reports.
     *
     * @generated from protobuf field: repeated rd.analyticsv2.reportbuilder.ReportParamsV2.Column columns = 3
     */
    columns: ReportParamsV2_Column[];
    /**
     * If set, sorts table output by the given column number. Superseded by sorts.
     *
     * @generated from protobuf field: int32 sort_column_index = 6
     */
    sortColumnIndex: number;
    /**
     * 0:no sort, 1:desc, 2:asc. Superseded by sorts.
     *
     * @generated from protobuf field: int32 sort_order = 7
     */
    sortOrder: number;
    /**
     * @generated from protobuf field: repeated rd.analyticsv2.reportbuilder.Filter filters = 8
     */
    filters: Filter[];
    /**
     * @generated from protobuf field: bool unaggregated = 9
     */
    unaggregated: boolean;
    /**
     * @generated from protobuf field: repeated rd.analyticsv2.reportbuilder.ReportParamsV2.SearchQuery search_queries = 10
     */
    searchQueries: ReportParamsV2_SearchQuery[];
    /**
     * @generated from protobuf field: repeated rd.analyticsv2.reportbuilder.PredicateFilter predicate_filters = 12
     */
    predicateFilters: PredicateFilter[];
    /**
     * If set, sorts table output by the matching column. Superseded by sorts.
     *
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.ReportParamsV2.SortColumnKey sort_column_key = 13
     */
    sortColumnKey?: ReportParamsV2_SortColumnKey;
    /**
     * @generated from protobuf field: repeated rd.proto.timestamprange.TimestampRange comparison_ranges = 15
     */
    comparisonRanges: TimestampRange[];
    /**
     * @generated from protobuf field: bool show_date_compared_percent_change = 16
     */
    showDateComparedPercentChange: boolean;
    /**
     * @generated from protobuf field: bool show_date_compared_delta = 17
     */
    showDateComparedDelta: boolean;
    /**
     * Ordered sort levels; first is primary, later levels break ties. Supersedes
     * sort_column_key/sort_order.
     *
     * @generated from protobuf field: repeated rd.analyticsv2.reportbuilder.ReportParamsV2.Sort sorts = 19
     */
    sorts: ReportParamsV2_Sort[];
    /**
     * ClientTimezone is the IANA timezone of the viewer's browser (e.g.
     * "America/New_York"). When set, absolute (non-relative) DataSourceRange /
     * ComparisonRanges are anchored to the company's default-location timezone so
     * the report period matches the store's accounting day regardless of who is
     * viewing it.
     *
     * @generated from protobuf field: string client_timezone = 18
     */
    clientTimezone: string;
}
/**
 * Column represents the configuration of each column.
 *
 * @generated from protobuf message rd.analyticsv2.reportbuilder.ReportParamsV2.Column
 */
export interface ReportParamsV2_Column {
    /**
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.GroupV2 group = 1
     */
    group: GroupV2;
    /**
     * Commonly leave empty for standard reports. Only include valid label enums (< 10000).
     *
     * @generated from protobuf field: repeated rd.analyticsv2.reportbuilder.GroupV2 subgroups = 2
     */
    subgroups: GroupV2[];
    /**
     * Aggregation defines the aggregation for the metric column. If
     * unspecified, the default for the metric (typically sum) will be used.
     *
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.Aggregation aggregation = 3
     */
    aggregation: Aggregation;
    /**
     * TimeFormat allows specifying a custom time format. Some groups, e.g.
     * SOLD_AT, represent timestamps, and this field allows defining the
     * desired format in terms of the timestamp groups (values in the 100-199 range).
     *
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.GroupV2 time_format = 4
     */
    timeFormat: GroupV2;
    /**
     * SummaryAggregation defines which aggregation to use for the final summary of each column.
     *
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.Aggregation summary_aggregation = 5
     */
    summaryAggregation: Aggregation;
    /**
     * IsNonAggregating tells the report builder to completely ignore this Column
     * if and only if it's a label AND ReportParamsV2.Unaggregated is false.
     * This is included as a convenience to the frontend to simplify management
     * of drill-down vs. group-by columns.
     *
     * @generated from protobuf field: bool is_non_aggregating = 6
     */
    isNonAggregating: boolean;
    /**
     * IsDateCompared is only applicable for metric columns.
     * true if date compares should be enabled, if this is the case subgroups are ignored
     * there must also be >1 ComparisonRanges for date comparisons to activate
     *
     * @generated from protobuf field: bool is_date_compared = 7
     */
    isDateCompared: boolean;
    /**
     * IsSummaryCardHidden is only applicable for summary columns.
     * True if the value should be hidden from the summary cards.
     *
     * @generated from protobuf field: bool is_summary_card_hidden = 8
     */
    isSummaryCardHidden: boolean;
}
/**
 * SearchQuery contains fields for performing full-text search to find
 * relevant records. The results of the queries will be added as filters to
 * the report. This allows specifying text-based descriptions of records,
 * primarily useful from AI. For each present query, if there is an exact
 * match on the object's identifier, then only this object will be returned.
 * Otherwise, all of the (partially) matching records will be used for the
 * report.
 *
 * @generated from protobuf message rd.analyticsv2.reportbuilder.ReportParamsV2.SearchQuery
 */
export interface ReportParamsV2_SearchQuery {
    /**
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.ReportParamsV2.SearchQuery.QueryType query_type = 1
     */
    queryType: ReportParamsV2_SearchQuery_QueryType;
    /**
     * @generated from protobuf field: string query = 2
     */
    query: string;
}
/**
 * @generated from protobuf enum rd.analyticsv2.reportbuilder.ReportParamsV2.SearchQuery.QueryType
 */
export enum ReportParamsV2_SearchQuery_QueryType {
    /**
     * @generated from protobuf enum value: QUERY_TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: QUERY_TYPE_PRODUCT = 1;
     */
    PRODUCT = 1,
    /**
     * @generated from protobuf enum value: QUERY_TYPE_CUSTOMER = 2;
     */
    CUSTOMER = 2,
    /**
     * @generated from protobuf enum value: QUERY_TYPE_LOCATION = 3;
     */
    LOCATION = 3,
    /**
     * @generated from protobuf enum value: QUERY_TYPE_STAFF = 4;
     */
    STAFF = 4,
    /**
     * @generated from protobuf enum value: QUERY_TYPE_PRODUCT_CATEGORY = 6;
     */
    PRODUCT_CATEGORY = 6,
    /**
     * @generated from protobuf enum value: QUERY_TYPE_VENDOR = 7;
     */
    VENDOR = 7,
    /**
     * @generated from protobuf enum value: QUERY_TYPE_SALE = 8;
     */
    SALE = 8,
    /**
     * @generated from protobuf enum value: QUERY_TYPE_CUSTOMER_TAG = 9;
     */
    CUSTOMER_TAG = 9,
    /**
     * @generated from protobuf enum value: QUERY_TYPE_PRODUCT_TAG = 10;
     */
    PRODUCT_TAG = 10
}
/**
 * DateCompareColumnKey uniquely identifies a comparison column
 *
 * @generated from protobuf message rd.analyticsv2.reportbuilder.ReportParamsV2.DateCompareColumnKey
 */
export interface ReportParamsV2_DateCompareColumnKey {
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange dc_range = 1
     */
    dcRange?: TimestampRange;
    /**
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.ReportParamsV2.DateCompareColumnKey.DateCompareColumnType dc_column_type = 2
     */
    dcColumnType: ReportParamsV2_DateCompareColumnKey_DateCompareColumnType;
}
/**
 * @generated from protobuf enum rd.analyticsv2.reportbuilder.ReportParamsV2.DateCompareColumnKey.DateCompareColumnType
 */
export enum ReportParamsV2_DateCompareColumnKey_DateCompareColumnType {
    /**
     * @generated from protobuf enum value: UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * a compared column
     *
     * @generated from protobuf enum value: COMPARISON = 1;
     */
    COMPARISON = 1,
    /**
     * percent diff
     *
     * @generated from protobuf enum value: PERCENT = 2;
     */
    PERCENT = 2,
    /**
     * delta
     *
     * @generated from protobuf enum value: DELTA = 3;
     */
    DELTA = 3
}
/**
 * Uniquely identifies any column in the table
 *
 * @generated from protobuf message rd.analyticsv2.reportbuilder.ReportParamsV2.SortColumnKey
 */
export interface ReportParamsV2_SortColumnKey {
    /**
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.GroupV2 group = 1
     */
    group: GroupV2;
    /**
     * @generated from protobuf field: repeated string subgroupValues = 2
     */
    subgroupValues: string[];
    /**
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.ReportParamsV2.DateCompareColumnKey dc_key = 3
     */
    dcKey?: ReportParamsV2_DateCompareColumnKey;
}
/**
 * Sort defines one sort level for table output.
 *
 * @generated from protobuf message rd.analyticsv2.reportbuilder.ReportParamsV2.Sort
 */
export interface ReportParamsV2_Sort {
    /**
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.ReportParamsV2.SortColumnKey column_key = 1
     */
    columnKey?: ReportParamsV2_SortColumnKey;
    /**
     * @generated from protobuf field: rd.analyticsv2.SortOrder order = 2
     */
    order: SortOrder;
}
/**
 * @generated from protobuf enum rd.analyticsv2.reportbuilder.ReportParamsV2.CompareUnit
 */
export enum ReportParamsV2_CompareUnit {
    /**
     * @generated from protobuf enum value: COMPARE_UNIT_NONE = 0;
     */
    NONE = 0,
    /**
     * @generated from protobuf enum value: COMPARE_UNIT_DAY = 1;
     */
    DAY = 1,
    /**
     * @generated from protobuf enum value: COMPARE_UNIT_MONTH = 2;
     */
    MONTH = 2,
    /**
     * @generated from protobuf enum value: COMPARE_UNIT_YEAR = 3;
     */
    YEAR = 3
}
/**
 * @generated from protobuf message rd.analyticsv2.reportbuilder.ColumnOption
 */
export interface ColumnOption {
    /**
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.GroupV2 group = 1
     */
    group: GroupV2;
    /**
     * @generated from protobuf field: string description = 2
     */
    description: string;
}
/**
 * @generated from protobuf message rd.analyticsv2.reportbuilder.SavedReport
 */
export interface SavedReport {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID; // report id
    /**
     * @generated from protobuf field: string identifier = 2
     */
    identifier: string; // report identifier
    /**
     * @generated from protobuf field: string name = 3
     */
    name: string; // report name, display name in table, title etc.
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 4
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.user.User created_by = 5
     */
    createdBy?: User; // the user who created the saved report
    /**
     * @generated from protobuf field: rd.user.User updated_by = 6
     */
    updatedBy?: User; // the user who updated the saved report
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 7
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 8
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.analyticsv2.reportbuilder.ReportParamsV2 params = 9
     */
    params?: ReportParamsV2; // the report configuration
    /**
     * @generated from protobuf field: bool is_global = 10
     */
    isGlobal: boolean;
    /**
     * @generated from protobuf field: map<string, int32> column_widths = 11
     */
    columnWidths: {
        [key: string]: number;
    };
}
/**
 * @generated from protobuf enum rd.analyticsv2.reportbuilder.DataSource
 */
export enum DataSource {
    /**
     * @generated from protobuf enum value: DATA_SOURCE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: DATA_SOURCE_SALES_REVENUE = 1;
     */
    SALES_REVENUE = 1,
    /**
     * TODO(brian): add back when implemented
     * DATA_SOURCE_SALES_MARGIN = 3;
     *
     * @generated from protobuf enum value: DATA_SOURCE_SALES_PROFIT = 2;
     */
    SALES_PROFIT = 2,
    /**
     * @generated from protobuf enum value: DATA_SOURCE_SALES_QUANTITY = 4;
     */
    SALES_QUANTITY = 4
}
/**
 * @generated from protobuf enum rd.analyticsv2.reportbuilder.Group
 */
export enum Group {
    /**
     * @generated from protobuf enum value: GROUP_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: GROUP_PRODUCT = 1;
     */
    PRODUCT = 1,
    /**
     * @generated from protobuf enum value: GROUP_DEPARTMENT = 2;
     */
    DEPARTMENT = 2,
    /**
     * @generated from protobuf enum value: GROUP_DAY = 3;
     */
    DAY = 3,
    /**
     * @generated from protobuf enum value: GROUP_MONTH = 4;
     */
    MONTH = 4,
    /**
     * @generated from protobuf enum value: GROUP_YEAR = 5;
     */
    YEAR = 5,
    /**
     * @generated from protobuf enum value: GROUP_CUSTOMER = 6;
     */
    CUSTOMER = 6,
    /**
     * @generated from protobuf enum value: GROUP_PRODUCT_TAG = 7;
     */
    PRODUCT_TAG = 7,
    /**
     * @generated from protobuf enum value: GROUP_CUSTOMER_TAG = 8;
     */
    CUSTOMER_TAG = 8,
    /**
     * @generated from protobuf enum value: GROUP_HOUR_OF_DAY = 9;
     */
    HOUR_OF_DAY = 9,
    /**
     * @generated from protobuf enum value: GROUP_DAY_OF_WEEK = 10;
     */
    DAY_OF_WEEK = 10,
    /**
     * @generated from protobuf enum value: GROUP_MONTH_OF_YEAR = 11;
     */
    MONTH_OF_YEAR = 11,
    /**
     * @generated from protobuf enum value: GROUP_DAY_OF_MONTH = 12;
     */
    DAY_OF_MONTH = 12,
    /**
     * @generated from protobuf enum value: GROUP_CLERK = 13;
     */
    CLERK = 13,
    /**
     * @generated from protobuf enum value: GROUP_LOCATION = 14;
     */
    LOCATION = 14
}
/**
 * BaseData is the dataset that the report will be based on. This determines
 * which underlying table the report's rows will be reduced from.
 * These base data enums should match the defined enums in rd/llm/tools/report.proto
 *
 * @generated from protobuf enum rd.analyticsv2.reportbuilder.BaseData
 */
export enum BaseData {
    /**
     * @generated from protobuf enum value: BASE_DATA_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * BASE_DATA_PRODUCTS contains general product information.
     *
     * @generated from protobuf enum value: BASE_DATA_PRODUCTS = 1;
     */
    PRODUCTS = 1,
    /**
     * BASE_DATA_CUSTOMERS contains general customer information.
     *
     * @generated from protobuf enum value: BASE_DATA_CUSTOMERS = 2;
     */
    CUSTOMERS = 2,
    /**
     * BASE_DATA_SOLD_PRODUCTS contains information on sale line items. It is the
     * primary table for sales-based analytics such as revenue. It is joined with
     * the SALES, CUSTOMERS, and PRODUCTS tables.
     *
     * @generated from protobuf enum value: BASE_DATA_SOLD_PRODUCTS = 3;
     */
    SOLD_PRODUCTS = 3,
    /**
     * BASE_DATA_SALES contains sale-level metrics. It should primarily be used
     * for sale-level information such as tax. It is joined with the CUSTOMERS
     * and PRODUCTS tables.
     *
     * @generated from protobuf enum value: BASE_DATA_SALES = 4;
     */
    SALES = 4,
    /**
     * @generated from protobuf enum value: BASE_DATA_ORDER_PRODUCTS = 5;
     */
    ORDER_PRODUCTS = 5,
    /**
     * @generated from protobuf enum value: BASE_DATA_TRANSFER_PRODUCTS = 6;
     */
    TRANSFER_PRODUCTS = 6,
    /**
     * @generated from protobuf enum value: BASE_DATA_INTERACTIONS = 7;
     */
    INTERACTIONS = 7,
    /**
     * @generated from protobuf enum value: BASE_DATA_VENDORS = 8;
     */
    VENDORS = 8,
    /**
     * Deprecated
     *
     * @generated from protobuf enum value: BASE_DATA_COUNTED_PRODUCTS = 9;
     */
    COUNTED_PRODUCTS = 9,
    /**
     * @generated from protobuf enum value: BASE_DATA_TRANSACTIONS = 12;
     */
    TRANSACTIONS = 12,
    /**
     * @generated from protobuf enum value: BASE_DATA_JOBS = 13;
     */
    JOBS = 13,
    /**
     * @generated from protobuf enum value: BASE_DATA_INVENTORY_COUNTS = 14;
     */
    INVENTORY_COUNTS = 14,
    /**
     * @generated from protobuf enum value: BASE_DATA_INVENTORY = 15;
     */
    INVENTORY = 15,
    /**
     * @generated from protobuf enum value: BASE_DATA_TAX_RATE = 16;
     */
    TAX_RATE = 16,
    /**
     * @generated from protobuf enum value: BASE_DATA_TAXABLE_TRANSACTIONS = 17;
     */
    TAXABLE_TRANSACTIONS = 17,
    /**
     * @generated from protobuf enum value: BASE_DATA_SHIPMENT_PRODUCTS = 19;
     */
    SHIPMENT_PRODUCTS = 19,
    /**
     * @generated from protobuf enum value: BASE_DATA_AGING_BY_TRANSACTION = 21;
     */
    AGING_BY_TRANSACTION = 21,
    /**
     * @generated from protobuf enum value: BASE_DATA_PRODUCT_COSTS = 22;
     */
    PRODUCT_COSTS = 22,
    /**
     * @generated from protobuf enum value: BASE_DATA_TAGS = 23;
     */
    TAGS = 23,
    /**
     * @generated from protobuf enum value: BASE_DATA_STAFF = 24;
     */
    STAFF = 24,
    /**
     * @generated from protobuf enum value: BASE_DATA_PRICE_RULES = 25;
     */
    PRICE_RULES = 25,
    /**
     * @generated from protobuf enum value: BASE_DATA_SOLD_PRODUCT_PRICING_TIERS = 26;
     */
    SOLD_PRODUCT_PRICING_TIERS = 26,
    /**
     * @generated from protobuf enum value: BASE_DATA_SPIFFS = 27;
     */
    SPIFFS = 27,
    /**
     * admin/accounting
     *
     * @generated from protobuf enum value: BASE_DATA_SINGLE_ENTRIES = 28;
     */
    SINGLE_ENTRIES = 28,
    /**
     * @generated from protobuf enum value: BASE_DATA_GIFT_CARD_BALANCES = 29;
     */
    GIFT_CARD_BALANCES = 29,
    /**
     * @generated from protobuf enum value: BASE_DATA_SINGLE_ENTRIES_POS = 30;
     */
    SINGLE_ENTRIES_POS = 30,
    /**
     * @generated from protobuf enum value: BASE_DATA_ROUTINES = 31;
     */
    ROUTINES = 31,
    /**
     * BASE_DATA_IN_PROGRESS_SALES is BASE_DATA_SALES but
     * filters by created_at instead of sold_at
     *
     * @generated from protobuf enum value: BASE_DATA_IN_PROGRESS_SALES = 32;
     */
    IN_PROGRESS_SALES = 32,
    /**
     * BASE_DATA_IN_PROGRESS_SALE_PRODUCTS is BASE_DATA_SOLD_PRODUCTS but
     * filters by created_at instead of sold_at
     *
     * @generated from protobuf enum value: BASE_DATA_IN_PROGRESS_SALE_PRODUCTS = 33;
     */
    IN_PROGRESS_SALE_PRODUCTS = 33,
    /**
     * @generated from protobuf enum value: BASE_DATA_PAYOUT_TRANSACTIONS = 34;
     */
    PAYOUT_TRANSACTIONS = 34,
    /**
     * BASE_DATA_ORDER_SHIPMENTS contains one row per order shipment, with
     * shipment-level cost totals and connections to order, vendor, and location.
     *
     * @generated from protobuf enum value: BASE_DATA_ORDER_SHIPMENTS = 35;
     */
    ORDER_SHIPMENTS = 35,
    /**
     * BASE_DATA_INVENTORY_TRANSACTIONS is a dedicated inventory-transaction dataset
     * that uses IsOriginalOrActive filtering so voided and replaced entries are
     * visible alongside their active counterparts.
     *
     * @generated from protobuf enum value: BASE_DATA_INVENTORY_TRANSACTIONS = 36;
     */
    INVENTORY_TRANSACTIONS = 36,
    /**
     * BASE_DATA_LOCATIONS contains one row per company location with location
     * fields and the associated ColorxLocation record.
     *
     * @generated from protobuf enum value: BASE_DATA_LOCATIONS = 37;
     */
    LOCATIONS = 37,
    /**
     * BASE_DATA_DELIVERIES contains one row per delivery with its stops, sales,
     * customers, driver, and dispatch location joined in.
     *
     * @generated from protobuf enum value: BASE_DATA_DELIVERIES = 38;
     */
    DELIVERIES = 38
}
/**
 * GroupV2 is used for defining desired columns in the table output as well as
 * subgrouping columns into additional columns. Enum values <10000 are
 * "labels"; there will be one row in the output for each unique set of labels.
 * Enum values >=10000 are metrics; these are numeric values and they are
 * allowed to be subgrouped by labels.
 *
 * ** enum values < 10000 are labels **
 *
 * @generated from protobuf enum rd.analyticsv2.reportbuilder.GroupV2
 */
export enum GroupV2 {
    /**
     * labels: general
     *
     * @generated from protobuf enum value: GROUPV2_UNDEFINED = 0;
     */
    GROUPV2_UNDEFINED = 0,
    /**
     * labels: timestamp
     *
     * @generated from protobuf enum value: GROUPV2_DATE = 100;
     */
    GROUPV2_DATE = 100,
    /**
     * @generated from protobuf enum value: GROUPV2_MONTH = 101;
     */
    GROUPV2_MONTH = 101,
    /**
     * @generated from protobuf enum value: GROUPV2_YEAR = 102;
     */
    GROUPV2_YEAR = 102,
    /**
     * @generated from protobuf enum value: GROUPV2_HOUR_OF_DAY = 103;
     */
    GROUPV2_HOUR_OF_DAY = 103,
    /**
     * @generated from protobuf enum value: GROUPV2_DAY_OF_WEEK = 104;
     */
    GROUPV2_DAY_OF_WEEK = 104,
    /**
     * @generated from protobuf enum value: GROUPV2_MONTH_OF_YEAR = 105;
     */
    GROUPV2_MONTH_OF_YEAR = 105,
    /**
     * @generated from protobuf enum value: GROUPV2_DAY_OF_MONTH = 106;
     */
    GROUPV2_DAY_OF_MONTH = 106,
    /**
     * @generated from protobuf enum value: GROUPV2_WEEK_OF_YEAR = 107;
     */
    GROUPV2_WEEK_OF_YEAR = 107,
    /**
     * @generated from protobuf enum value: GROUPV2_DATE_AND_TIME = 108;
     */
    GROUPV2_DATE_AND_TIME = 108,
    /**
     * @generated from protobuf enum value: GROUPV2_DATE_AND_TIME_SECONDS = 109;
     */
    GROUPV2_DATE_AND_TIME_SECONDS = 109,
    /**
     * labels: product
     *
     * @generated from protobuf enum value: GROUPV2_PRODUCT = 200;
     */
    GROUPV2_PRODUCT = 200,
    /**
     * @generated from protobuf enum value: GROUPV2_PRODUCT_ADDITIONAL_IDENTIFIERS = 201;
     */
    GROUPV2_PRODUCT_ADDITIONAL_IDENTIFIERS = 201,
    /**
     * @generated from protobuf enum value: GROUPV2_PRODUCT_NAME = 202;
     */
    GROUPV2_PRODUCT_NAME = 202,
    /**
     * @generated from protobuf enum value: GROUPV2_PRODUCT_TAGS = 203;
     */
    GROUPV2_PRODUCT_TAGS = 203,
    /**
     * @generated from protobuf enum value: GROUPV2_PRODUCT_DEPARTMENT = 204;
     */
    GROUPV2_PRODUCT_DEPARTMENT = 204,
    /**
     * @generated from protobuf enum value: GROUPV2_PRODUCT_CLASS = 205;
     */
    GROUPV2_PRODUCT_CLASS = 205,
    /**
     * @generated from protobuf enum value: GROUPV2_PRODUCT_FINELINE = 206;
     */
    GROUPV2_PRODUCT_FINELINE = 206,
    /**
     * @generated from protobuf enum value: GROUPV2_PRODUCT_TAXABLE = 208;
     */
    GROUPV2_PRODUCT_TAXABLE = 208,
    /**
     * @generated from protobuf enum value: GROUPV2_PRODUCT_ACTIVE = 209;
     */
    GROUPV2_PRODUCT_ACTIVE = 209,
    /**
     * @generated from protobuf enum value: GROUPV2_PRODUCT_DEFAULT_VENDOR = 210;
     */
    GROUPV2_PRODUCT_DEFAULT_VENDOR = 210,
    /**
     * @generated from protobuf enum value: GROUPV2_PRODUCT_MIN = 211;
     */
    GROUPV2_PRODUCT_MIN = 211,
    /**
     * @generated from protobuf enum value: GROUPV2_PRODUCT_MAX = 212;
     */
    GROUPV2_PRODUCT_MAX = 212,
    /**
     * @generated from protobuf enum value: GROUPV2_INTERNAL_PRODUCT_NOTES = 213;
     */
    GROUPV2_INTERNAL_PRODUCT_NOTES = 213,
    /**
     * @generated from protobuf enum value: GROUPV2_PRODUCT_IS_NON_STOCK = 214;
     */
    GROUPV2_PRODUCT_IS_NON_STOCK = 214,
    /**
     * @generated from protobuf enum value: GROUPV2_PRODUCT_IS_SPECIAL_ORDERABLE = 215;
     */
    GROUPV2_PRODUCT_IS_SPECIAL_ORDERABLE = 215,
    /**
     * @generated from protobuf enum value: GROUPV2_PRODUCT_IS_TINTABLE = 216;
     */
    GROUPV2_PRODUCT_IS_TINTABLE = 216,
    /**
     * unique to (product, location)
     *
     * @generated from protobuf enum value: GROUPV2_PRODUCT_BIN = 217;
     */
    GROUPV2_PRODUCT_BIN = 217,
    /**
     * unique to (product, location)
     *
     * @generated from protobuf enum value: GROUPV2_PRODUCT_LAST_PRINTED_AT = 218;
     */
    GROUPV2_PRODUCT_LAST_PRINTED_AT = 218,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER_PRODUCT_TEMPLATE_NOTES = 219;
     */
    GROUPV2_ORDER_PRODUCT_TEMPLATE_NOTES = 219,
    /**
     * unique to (product, location)
     *
     * @generated from protobuf enum value: GROUPV2_PRODUCT_PRICE_UPDATED_AT = 220;
     */
    GROUPV2_PRODUCT_PRICE_UPDATED_AT = 220,
    /**
     * labels: customer
     *
     * @generated from protobuf enum value: GROUPV2_CUSTOMER = 300;
     */
    GROUPV2_CUSTOMER = 300,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_NAME = 301;
     */
    GROUPV2_CUSTOMER_NAME = 301,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_ADDRESS = 302;
     */
    GROUPV2_CUSTOMER_ADDRESS = 302,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_TAGS = 303;
     */
    GROUPV2_CUSTOMER_TAGS = 303,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_PRIMARY_LOCATION = 304;
     */
    GROUPV2_CUSTOMER_PRIMARY_LOCATION = 304,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_CREATED_AT = 306;
     */
    GROUPV2_CUSTOMER_CREATED_AT = 306,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_CREDIT_HOLD = 307;
     */
    GROUPV2_CUSTOMER_CREDIT_HOLD = 307,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_PRICING_TIER = 308;
     */
    GROUPV2_CUSTOMER_PRICING_TIER = 308,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_FINANCE_TERM = 309;
     */
    GROUPV2_CUSTOMER_FINANCE_TERM = 309,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_STATEMENT_TYPE = 310;
     */
    GROUPV2_CUSTOMER_STATEMENT_TYPE = 310,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_SALES_REP = 311;
     */
    GROUPV2_CUSTOMER_SALES_REP = 311,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_FINANCE_RATE = 312;
     */
    GROUPV2_CUSTOMER_FINANCE_RATE = 312,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_PRIMARY_CONTACT_PHONE = 313;
     */
    GROUPV2_CUSTOMER_PRIMARY_CONTACT_PHONE = 313,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_PRIMARY_CONTACT_NAME = 314;
     */
    GROUPV2_CUSTOMER_PRIMARY_CONTACT_NAME = 314,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_CREATED_BY = 315;
     */
    GROUPV2_CUSTOMER_CREATED_BY = 315,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_LAST_SALE_AT = 316;
     */
    GROUPV2_CUSTOMER_LAST_SALE_AT = 316,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOM_TAX_RATE_NAME = 317;
     */
    GROUPV2_CUSTOM_TAX_RATE_NAME = 317,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_ACTIVE = 318;
     */
    GROUPV2_CUSTOMER_ACTIVE = 318,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_PRIMARY_CONTACT_EMAIL = 319;
     */
    GROUPV2_CUSTOMER_PRIMARY_CONTACT_EMAIL = 319,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_INTERNAL_NOTES = 320;
     */
    GROUPV2_CUSTOMER_INTERNAL_NOTES = 320,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_PRIMARY_CONTACT_NOTES = 321;
     */
    GROUPV2_CUSTOMER_PRIMARY_CONTACT_NOTES = 321,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_SALE_REMINDER = 322;
     */
    GROUPV2_CUSTOMER_SALE_REMINDER = 322,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_UPDATED_AT = 323;
     */
    GROUPV2_CUSTOMER_UPDATED_AT = 323,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_ADDRESS_LINE_1 = 324;
     */
    GROUPV2_CUSTOMER_ADDRESS_LINE_1 = 324,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_ADDRESS_LINE_2 = 325;
     */
    GROUPV2_CUSTOMER_ADDRESS_LINE_2 = 325,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_ADDRESS_CITY = 326;
     */
    GROUPV2_CUSTOMER_ADDRESS_CITY = 326,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_ADDRESS_STATE = 327;
     */
    GROUPV2_CUSTOMER_ADDRESS_STATE = 327,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_ADDRESS_POSTAL_CODE = 328;
     */
    GROUPV2_CUSTOMER_ADDRESS_POSTAL_CODE = 328,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_BENJAMIN_MOORE_CUSTOMER_TYPE = 329;
     */
    GROUPV2_CUSTOMER_BENJAMIN_MOORE_CUSTOMER_TYPE = 329,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_BENJAMIN_MOORE_PAX_ID = 330;
     */
    GROUPV2_CUSTOMER_BENJAMIN_MOORE_PAX_ID = 330,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_BENJAMIN_MOORE_RSD_NUMBER = 331;
     */
    GROUPV2_CUSTOMER_BENJAMIN_MOORE_RSD_NUMBER = 331,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_AUTOPAY_STATEMENT_BALANCES = 332;
     */
    GROUPV2_CUSTOMER_AUTOPAY_STATEMENT_BALANCES = 332,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_MAIL_STATEMENTS = 333;
     */
    GROUPV2_CUSTOMER_MAIL_STATEMENTS = 333,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_STATEMENT_INVOICES_FORMAT = 334;
     */
    GROUPV2_CUSTOMER_STATEMENT_INVOICES_FORMAT = 334,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_RESTRICT_OUTSTANDING_INVOICE_PDFS = 335;
     */
    GROUPV2_CUSTOMER_RESTRICT_OUTSTANDING_INVOICE_PDFS = 335,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_REQUIRE_PO = 336;
     */
    GROUPV2_CUSTOMER_REQUIRE_PO = 336,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_REQUIRE_JOB = 337;
     */
    GROUPV2_CUSTOMER_REQUIRE_JOB = 337,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_REQUIRE_BUYER = 338;
     */
    GROUPV2_CUSTOMER_REQUIRE_BUYER = 338,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_REQUIRE_RECEIPT_SIGNATURE = 339;
     */
    GROUPV2_CUSTOMER_REQUIRE_RECEIPT_SIGNATURE = 339,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_REQUIRE_SALES_NOTES = 340;
     */
    GROUPV2_CUSTOMER_REQUIRE_SALES_NOTES = 340,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_REQUIRE_INTERNAL_SALES_NOTES = 341;
     */
    GROUPV2_CUSTOMER_REQUIRE_INTERNAL_SALES_NOTES = 341,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_HIDE_PRICES_ON_INVOICES = 342;
     */
    GROUPV2_CUSTOMER_HIDE_PRICES_ON_INVOICES = 342,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_EXEMPT_FROM_CARD_SURCHARGE = 343;
     */
    GROUPV2_CUSTOMER_EXEMPT_FROM_CARD_SURCHARGE = 343,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_ECO_FEE_NUMBER = 344;
     */
    GROUPV2_CUSTOMER_ECO_FEE_NUMBER = 344,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_SALES_TAX_NUMBER = 345;
     */
    GROUPV2_CUSTOMER_SALES_TAX_NUMBER = 345,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_SINGLE_USE_TAX_NUMBER = 346;
     */
    GROUPV2_CUSTOMER_SINGLE_USE_TAX_NUMBER = 346,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_USE_CUSTOM_TAX_RATE = 347;
     */
    GROUPV2_CUSTOMER_USE_CUSTOM_TAX_RATE = 347,
    /**
     * labels: sale
     *
     * only populated for TYPE_SALE, not TYPE_RETURN
     *
     * @generated from protobuf enum value: GROUPV2_SALE = 400;
     */
    GROUPV2_SALE = 400,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE_SOLD_BY = 401;
     */
    GROUPV2_SALE_SOLD_BY = 401,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE_TAX_RATE = 402;
     */
    GROUPV2_SALE_TAX_RATE = 402,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE_NOTES = 403;
     */
    GROUPV2_SALE_NOTES = 403,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE_TYPE = 404;
     */
    GROUPV2_SALE_TYPE = 404,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE_INTERNAL_NOTES = 405;
     */
    GROUPV2_SALE_INTERNAL_NOTES = 405,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE_PURCHASE_ORDER_NAME = 406;
     */
    GROUPV2_SALE_PURCHASE_ORDER_NAME = 406,
    /**
     * Draft, Quote, Will call, Special order, Sold, Voided
     *
     * @generated from protobuf enum value: GROUPV2_SALE_STATUS = 407;
     */
    GROUPV2_SALE_STATUS = 407,
    /**
     * only populated for TYPE_RETURN
     *
     * @generated from protobuf enum value: GROUPV2_RETURN = 408;
     */
    GROUPV2_RETURN = 408,
    /**
     * sale's selected customer contact name
     *
     * @generated from protobuf enum value: GROUPV2_SALE_BUYER = 409;
     */
    GROUPV2_SALE_BUYER = 409,
    /**
     * sale's address string
     *
     * @generated from protobuf enum value: GROUPV2_SALE_ADDRESS = 410;
     */
    GROUPV2_SALE_ADDRESS = 410,
    /**
     * whether sale/return has been paid/refunded
     *
     * @generated from protobuf enum value: GROUPV2_SALE__IS_PAID = 411;
     */
    GROUPV2_SALE__IS_PAID = 411,
    /**
     * sale's fulfillment location
     *
     * @generated from protobuf enum value: GROUPV2_SALE_FULFILLMENT_LOCATION = 412;
     */
    GROUPV2_SALE_FULFILLMENT_LOCATION = 412,
    /**
     * whether sale is delivery fulfillment
     *
     * @generated from protobuf enum value: GROUPV2_SALE_IS_DELIVERY_FULFILLMENT = 413;
     */
    GROUPV2_SALE_IS_DELIVERY_FULFILLMENT = 413,
    /**
     * sale's delivery date
     *
     * @generated from protobuf enum value: GROUPV2_SALE_DELIVERY_DATE = 414;
     */
    GROUPV2_SALE_DELIVERY_DATE = 414,
    /**
     * POS or E-commerce
     *
     * @generated from protobuf enum value: GROUPV2_SALE_SOURCE = 415;
     */
    GROUPV2_SALE_SOURCE = 415,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE_CREATED_BY = 416;
     */
    GROUPV2_SALE_CREATED_BY = 416,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE_QUOTED_BY = 417;
     */
    GROUPV2_SALE_QUOTED_BY = 417,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE_WILL_CALLED_BY = 418;
     */
    GROUPV2_SALE_WILL_CALLED_BY = 418,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE_SPECIAL_ORDERED_BY = 419;
     */
    GROUPV2_SALE_SPECIAL_ORDERED_BY = 419,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE_VOIDED_BY = 420;
     */
    GROUPV2_SALE_VOIDED_BY = 420,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE_DESIGNATED_CLERK = 421;
     */
    GROUPV2_SALE_DESIGNATED_CLERK = 421,
    /**
     * per-rate tax rate percents, comma separated
     *
     * @generated from protobuf enum value: GROUPV2_SALE__TAX_RATES = 422;
     */
    GROUPV2_SALE__TAX_RATES = 422,
    /**
     * per-rate base sales tax, comma separated
     *
     * @generated from protobuf enum value: GROUPV2_SALE__BASE_SALES_TAXES = 423;
     */
    GROUPV2_SALE__BASE_SALES_TAXES = 423,
    /**
     * per-rate surcharge tax, comma separated
     *
     * @generated from protobuf enum value: GROUPV2_SALE__SURCHARGE_TAXES = 424;
     */
    GROUPV2_SALE__SURCHARGE_TAXES = 424,
    /**
     * identifiers of the deliveries carrying the sale
     *
     * @generated from protobuf enum value: GROUPV2_SALE_DELIVERIES = 425;
     */
    GROUPV2_SALE_DELIVERIES = 425,
    /**
     * labels: sold product
     *
     * @generated from protobuf enum value: GROUPV2_SOLD_PRODUCT_FEE_NAME = 500;
     */
    GROUPV2_SOLD_PRODUCT_FEE_NAME = 500,
    /**
     * @generated from protobuf enum value: GROUPV2_SOLD_PRODUCT_IS_TAXED = 501;
     */
    GROUPV2_SOLD_PRODUCT_IS_TAXED = 501,
    /**
     * @generated from protobuf enum value: GROUPV2_SOLD_PRODUCT_IS_FEE_TAXED = 502;
     */
    GROUPV2_SOLD_PRODUCT_IS_FEE_TAXED = 502,
    /**
     * @generated from protobuf enum value: GROUPV2_SOLD_PRODUCT_IS_PRICE_EDITED = 503;
     */
    GROUPV2_SOLD_PRODUCT_IS_PRICE_EDITED = 503,
    /**
     * @generated from protobuf enum value: GROUPV2_SOLD_PRODUCT_TINT_NAME = 505;
     */
    GROUPV2_SOLD_PRODUCT_TINT_NAME = 505,
    /**
     * @generated from protobuf enum value: GROUPV2_SOLD_PRODUCT_TINT_COMPANY = 506;
     */
    GROUPV2_SOLD_PRODUCT_TINT_COMPANY = 506,
    /**
     * @generated from protobuf enum value: GROUPV2_SOLD_PRODUCT_CUSTOM_TINT = 507;
     */
    GROUPV2_SOLD_PRODUCT_CUSTOM_TINT = 507,
    /**
     * @generated from protobuf enum value: GROUPV2_SOLD_PRODUCT_NOTES = 508;
     */
    GROUPV2_SOLD_PRODUCT_NOTES = 508,
    /**
     * @generated from protobuf enum value: GROUPV2_SOLD_PRODUCT_TINT_CODE = 509;
     */
    GROUPV2_SOLD_PRODUCT_TINT_CODE = 509,
    /**
     * per-rate sold product tax, comma separated
     *
     * @generated from protobuf enum value: GROUPV2_SOLD_PRODUCT__PRODUCT_TAXES = 511;
     */
    GROUPV2_SOLD_PRODUCT__PRODUCT_TAXES = 511,
    /**
     * short name "Paid at"
     *
     * @generated from protobuf enum value: GROUPV2_SOLD_PRODUCT__PAID_AT = 512;
     */
    GROUPV2_SOLD_PRODUCT__PAID_AT = 512,
    /**
     * @generated from protobuf enum value: GROUPV2_SOLD_PRODUCT__LINKED_RETURN = 513;
     */
    GROUPV2_SOLD_PRODUCT__LINKED_RETURN = 513,
    /**
     * labels: location
     *
     * @generated from protobuf enum value: GROUPV2_LOCATION = 600;
     */
    GROUPV2_LOCATION = 600,
    /**
     * @generated from protobuf enum value: GROUPV2_LOCATION_PREFIX = 601;
     */
    GROUPV2_LOCATION_PREFIX = 601,
    /**
     * @generated from protobuf enum value: GROUPV2_LOCATION_NAME = 602;
     */
    GROUPV2_LOCATION_NAME = 602,
    /**
     * @generated from protobuf enum value: GROUPV2_ACCOUNTING_LOCATION = 603;
     */
    GROUPV2_ACCOUNTING_LOCATION = 603,
    /**
     * @generated from protobuf enum value: GROUPV2_LOCATION_ADDRESS = 604;
     */
    GROUPV2_LOCATION_ADDRESS = 604,
    /**
     * @generated from protobuf enum value: GROUPV2_LOCATION_IS_ACTIVE = 605;
     */
    GROUPV2_LOCATION_IS_ACTIVE = 605,
    /**
     * @generated from protobuf enum value: GROUPV2_LOCATION_BENJAMIN_MOORE_OUTLET_NUMBER = 606;
     */
    GROUPV2_LOCATION_BENJAMIN_MOORE_OUTLET_NUMBER = 606,
    /**
     * @generated from protobuf enum value: GROUPV2_LOCATION_COLORX_SITE_KEY = 607;
     */
    GROUPV2_LOCATION_COLORX_SITE_KEY = 607,
    /**
     * labels: bill payment
     *
     * @generated from protobuf enum value: GROUPV2_BILL_PAYMENT = 700;
     */
    GROUPV2_BILL_PAYMENT = 700,
    /**
     * labels: write-off
     *
     * @generated from protobuf enum value: GROUPV2_WRITE_OFF = 800;
     */
    GROUPV2_WRITE_OFF = 800,
    /**
     * labels: vendors
     *
     * @generated from protobuf enum value: GROUPV2_VENDOR_NAME = 900;
     */
    GROUPV2_VENDOR_NAME = 900,
    /**
     * @generated from protobuf enum value: GROUPV2_VENDOR_PAY_TO = 901;
     */
    GROUPV2_VENDOR_PAY_TO = 901,
    /**
     * @generated from protobuf enum value: GROUPV2_VENDOR_ORDERS_EMAIL = 902;
     */
    GROUPV2_VENDOR_ORDERS_EMAIL = 902,
    /**
     * @generated from protobuf enum value: GROUPV2_VENDOR_PHONE = 903;
     */
    GROUPV2_VENDOR_PHONE = 903,
    /**
     * @generated from protobuf enum value: GROUPV2_VENDOR_MAILING_ADDRESS = 904;
     */
    GROUPV2_VENDOR_MAILING_ADDRESS = 904,
    /**
     * @generated from protobuf enum value: GROUPV2_VENDOR_INTERNAL_NOTES = 905;
     */
    GROUPV2_VENDOR_INTERNAL_NOTES = 905,
    /**
     * TODO: vendors account number by location
     *
     * @generated from protobuf enum value: GROUPV2_VENDOR_INTEGRATION_VENDOR = 906;
     */
    GROUPV2_VENDOR_INTEGRATION_VENDOR = 906,
    /**
     * labels: interaction
     *
     * @generated from protobuf enum value: GROUPV2_INTERACTION_STAFF = 1000;
     */
    GROUPV2_INTERACTION_STAFF = 1000,
    /**
     * @generated from protobuf enum value: GROUPV2_INTERACTION = 1001;
     */
    GROUPV2_INTERACTION = 1001,
    /**
     * labels: order
     *
     * @generated from protobuf enum value: GROUPV2_ORDER = 1100;
     */
    GROUPV2_ORDER = 1100,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER_CREATED_BY = 1101;
     */
    GROUPV2_ORDER_CREATED_BY = 1101,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER_ORDERED_BY = 1102;
     */
    GROUPV2_ORDER_ORDERED_BY = 1102,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER_RECEIVED_BY = 1103;
     */
    GROUPV2_ORDER_RECEIVED_BY = 1103,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER_VOIDED_BY = 1104;
     */
    GROUPV2_ORDER_VOIDED_BY = 1104,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER_CREATED_AT = 1105;
     */
    GROUPV2_ORDER_CREATED_AT = 1105,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER_ORDERED_AT = 1106;
     */
    GROUPV2_ORDER_ORDERED_AT = 1106,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER_RECEIVED_AT = 1107;
     */
    GROUPV2_ORDER_RECEIVED_AT = 1107,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER_VOIDED_AT = 1108;
     */
    GROUPV2_ORDER_VOIDED_AT = 1108,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER_STATUS = 1109;
     */
    GROUPV2_ORDER_STATUS = 1109,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER_ORDER_NOTES = 1110;
     */
    GROUPV2_ORDER_ORDER_NOTES = 1110,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER_INTERNAL_NOTES = 1111;
     */
    GROUPV2_ORDER_INTERNAL_NOTES = 1111,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER_METHOD = 1112;
     */
    GROUPV2_ORDER_METHOD = 1112,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER_SHIP_TO = 1113;
     */
    GROUPV2_ORDER_SHIP_TO = 1113,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER_INVOICE_NUMBER = 1114;
     */
    GROUPV2_ORDER_INVOICE_NUMBER = 1114,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER_INVOICE_REFERENCE_NUMBER = 1115;
     */
    GROUPV2_ORDER_INVOICE_REFERENCE_NUMBER = 1115,
    /**
     * labels: transfers
     *
     * @generated from protobuf enum value: GROUPV2_TRANSFER = 1200;
     */
    GROUPV2_TRANSFER = 1200,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSFER_FROM_LOCATION = 1201;
     */
    GROUPV2_TRANSFER_FROM_LOCATION = 1201,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSFER_TO_LOCATION = 1202;
     */
    GROUPV2_TRANSFER_TO_LOCATION = 1202,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSFER_CREATED_BY = 1203;
     */
    GROUPV2_TRANSFER_CREATED_BY = 1203,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSFER_REQUESTED_BY = 1204;
     */
    GROUPV2_TRANSFER_REQUESTED_BY = 1204,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSFER_SENT_BY = 1205;
     */
    GROUPV2_TRANSFER_SENT_BY = 1205,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSFER_RECEIVED_BY = 1206;
     */
    GROUPV2_TRANSFER_RECEIVED_BY = 1206,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSFER_VOIDED_BY = 1207;
     */
    GROUPV2_TRANSFER_VOIDED_BY = 1207,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSFER_CREATED_AT = 1208;
     */
    GROUPV2_TRANSFER_CREATED_AT = 1208,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSFER_REQUESTED_AT = 1209;
     */
    GROUPV2_TRANSFER_REQUESTED_AT = 1209,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSFER_SENT_AT = 1210;
     */
    GROUPV2_TRANSFER_SENT_AT = 1210,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSFER_RECEIVED_AT = 1211;
     */
    GROUPV2_TRANSFER_RECEIVED_AT = 1211,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSFER_VOIDED_AT = 1212;
     */
    GROUPV2_TRANSFER_VOIDED_AT = 1212,
    /**
     * labels: job
     *
     * @generated from protobuf enum value: GROUPV2_JOB = 1300;
     */
    GROUPV2_JOB = 1300,
    /**
     * @generated from protobuf enum value: GROUPV2_JOB_NAME = 1301;
     */
    GROUPV2_JOB_NAME = 1301,
    /**
     * labels: transactions general
     *
     * @generated from protobuf enum value: GROUPV2_TRANSACTION = 1400;
     */
    GROUPV2_TRANSACTION = 1400,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSACTION_TYPE = 1401;
     */
    GROUPV2_TRANSACTION_TYPE = 1401,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSACTION_IS_CASH = 1402;
     */
    GROUPV2_TRANSACTION_IS_CASH = 1402,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSACTION_IS_TAX_RELEVANT = 1403;
     */
    GROUPV2_TRANSACTION_IS_TAX_RELEVANT = 1403,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSACTION_BALANCE = 1404;
     */
    GROUPV2_TRANSACTION_BALANCE = 1404,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSACTION_IS_RECEIVABLE = 1405;
     */
    GROUPV2_TRANSACTION_IS_RECEIVABLE = 1405,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSACTION_STATUS = 1406;
     */
    GROUPV2_TRANSACTION_STATUS = 1406,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSACTION_CASH_REGISTER = 1407;
     */
    GROUPV2_TRANSACTION_CASH_REGISTER = 1407,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSACTION_CHECK_NUMBER = 1408;
     */
    GROUPV2_TRANSACTION_CHECK_NUMBER = 1408,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSACTION_IS_GIFT_CARD_TXN = 1410;
     */
    GROUPV2_TRANSACTION_IS_GIFT_CARD_TXN = 1410,
    /**
     * @generated from protobuf enum value: GROUPV2_GIFT_CARD_NUMBER_LAST_4 = 1411;
     */
    GROUPV2_GIFT_CARD_NUMBER_LAST_4 = 1411,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSACTION_INVENTORY_SUBTYPE = 1412;
     */
    GROUPV2_TRANSACTION_INVENTORY_SUBTYPE = 1412,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSACTION_IS_INVENTORY = 1413;
     */
    GROUPV2_TRANSACTION_IS_INVENTORY = 1413,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSACTION_NOTES = 1414;
     */
    GROUPV2_TRANSACTION_NOTES = 1414,
    /**
     * labels: transaction payments
     *
     * @generated from protobuf enum value: GROUPV2_PAYMENT_PROCESSING_ID = 1500;
     */
    GROUPV2_PAYMENT_PROCESSING_ID = 1500,
    /**
     * @generated from protobuf enum value: GROUPV2_PAYMENT_CHECK_NUMBER = 1501;
     */
    GROUPV2_PAYMENT_CHECK_NUMBER = 1501,
    /**
     * @generated from protobuf enum value: GROUPV2_TENDER_METHOD = 1502;
     */
    GROUPV2_TENDER_METHOD = 1502,
    /**
     * @generated from protobuf enum value: GROUPV2_PAYMENT_ENTITY = 1503;
     */
    GROUPV2_PAYMENT_ENTITY = 1503,
    /**
     * @generated from protobuf enum value: GROUPV2_PAYMENT_PAYOUT = 1504;
     */
    GROUPV2_PAYMENT_PAYOUT = 1504,
    /**
     * @generated from protobuf enum value: GROUPV2_PAYMENT_STATUS = 1505;
     */
    GROUPV2_PAYMENT_STATUS = 1505,
    /**
     * @generated from protobuf enum value: GROUPV2_PAYMENT_PAYOUT_DATE = 1506;
     */
    GROUPV2_PAYMENT_PAYOUT_DATE = 1506,
    /**
     * @generated from protobuf enum value: GROUPV2_PAYMENT_PAYOUT_TXN_TYPE = 1507;
     */
    GROUPV2_PAYMENT_PAYOUT_TXN_TYPE = 1507,
    /**
     * @generated from protobuf enum value: GROUPV2_PAYMENT_PAYOUT_TOTAL = 1508;
     */
    GROUPV2_PAYMENT_PAYOUT_TOTAL = 1508,
    /**
     * @generated from protobuf enum value: GROUPV2_PAYMENT_UNLINKED_REFUND_ID = 1509;
     */
    GROUPV2_PAYMENT_UNLINKED_REFUND_ID = 1509,
    /**
     * labels: counted products
     *
     * @generated from protobuf enum value: GROUPV2_COUNTED_PRODUCTS = 1700;
     */
    GROUPV2_COUNTED_PRODUCTS = 1700,
    /**
     * @generated from protobuf enum value: GROUPV2_COUNTED_PRODUCTS_PRODUCT_STATUS = 1701;
     */
    GROUPV2_COUNTED_PRODUCTS_PRODUCT_STATUS = 1701,
    /**
     * @generated from protobuf enum value: GROUPV2_COUNTED_PRODUCTS_CREATED_BY = 1702;
     */
    GROUPV2_COUNTED_PRODUCTS_CREATED_BY = 1702,
    /**
     * @generated from protobuf enum value: GROUPV2_COUNTED_PRODUCTS_UPDATED_BY = 1703;
     */
    GROUPV2_COUNTED_PRODUCTS_UPDATED_BY = 1703,
    /**
     * labels: transaction finance charges
     *
     * @generated from protobuf enum value: GROUPV2_FINANCE_CHARGE = 1800;
     */
    GROUPV2_FINANCE_CHARGE = 1800,
    /**
     * @generated from protobuf enum value: GROUPV2_FINANCE_CHARGE_RATE = 1801;
     */
    GROUPV2_FINANCE_CHARGE_RATE = 1801,
    /**
     * @generated from protobuf enum value: GROUPV2_FINANCE_CHARGE_COMPOUNDS = 1802;
     */
    GROUPV2_FINANCE_CHARGE_COMPOUNDS = 1802,
    /**
     * @generated from protobuf enum value: GROUPV2_FINANCE_CHARGE_TERM = 1803;
     */
    GROUPV2_FINANCE_CHARGE_TERM = 1803,
    /**
     * @generated from protobuf enum value: GROUPV2_FINANCE_CHARGE_STATUS = 1805;
     */
    GROUPV2_FINANCE_CHARGE_STATUS = 1805,
    /**
     * labels: inventory counts
     *
     * @generated from protobuf enum value: GROUPV2_INVENTORY_COUNT = 1900;
     */
    GROUPV2_INVENTORY_COUNT = 1900,
    /**
     * @generated from protobuf enum value: GROUPV2_INVENTORY_COUNT_STATUS = 1901;
     */
    GROUPV2_INVENTORY_COUNT_STATUS = 1901,
    /**
     * @generated from protobuf enum value: GROUPV2_INVENTORY_COUNT_CREATED_BY = 1902;
     */
    GROUPV2_INVENTORY_COUNT_CREATED_BY = 1902,
    /**
     * @generated from protobuf enum value: GROUPV2_INVENTORY_COUNT_ACCEPTED_BY = 1903;
     */
    GROUPV2_INVENTORY_COUNT_ACCEPTED_BY = 1903,
    /**
     * @generated from protobuf enum value: GROUPV2_INVENTORY_COUNT_VOIDED_BY = 1904;
     */
    GROUPV2_INVENTORY_COUNT_VOIDED_BY = 1904,
    /**
     * @generated from protobuf enum value: GROUPV2_INVENTORY_COUNT_CREATED_AT = 1905;
     */
    GROUPV2_INVENTORY_COUNT_CREATED_AT = 1905,
    /**
     * @generated from protobuf enum value: GROUPV2_INVENTORY_COUNT_TYPE = 1906;
     */
    GROUPV2_INVENTORY_COUNT_TYPE = 1906,
    /**
     * @generated from protobuf enum value: GROUPV2_INVENTORY_COUNT_NOTES = 1907;
     */
    GROUPV2_INVENTORY_COUNT_NOTES = 1907,
    /**
     * @generated from protobuf enum value: GROUPV2_INVENTORY_LAST_SALE_DATE = 1908;
     */
    GROUPV2_INVENTORY_LAST_SALE_DATE = 1908,
    /**
     * @generated from protobuf enum value: GROUPV2_INVENTORY_LAST_ORDER_DATE = 1909;
     */
    GROUPV2_INVENTORY_LAST_ORDER_DATE = 1909,
    /**
     * labels: order product
     *
     * @generated from protobuf enum value: GROUPV2_ORDER_PRODUCT_IS_SPECIAL_ORDER = 2300;
     */
    GROUPV2_ORDER_PRODUCT_IS_SPECIAL_ORDER = 2300,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER_PRODUCT_NOTES = 2301;
     */
    GROUPV2_ORDER_PRODUCT_NOTES = 2301,
    /**
     * labels: tax rate
     *
     * @generated from protobuf enum value: GROUPV2_TAX_RATE = 2400;
     */
    GROUPV2_TAX_RATE = 2400,
    /**
     * @generated from protobuf enum value: GROUPV2_TAX_RATE_NAME = 2401;
     */
    GROUPV2_TAX_RATE_NAME = 2401,
    /**
     * @generated from protobuf enum value: GROUPV2_TAX_RATE_POSITION = 2402;
     */
    GROUPV2_TAX_RATE_POSITION = 2402,
    /**
     * @generated from protobuf enum value: GROUPV2_TAX_RATE_IS_ACTIVE = 2403;
     */
    GROUPV2_TAX_RATE_IS_ACTIVE = 2403,
    /**
     * @generated from protobuf enum value: GROUPV2_TAX_RATE_TYPE = 2404;
     */
    GROUPV2_TAX_RATE_TYPE = 2404,
    /**
     * labels: transaction taxes
     *
     * sale, return, payment, refund
     *
     * @generated from protobuf enum value: GROUPV2_TYPE = 2500;
     */
    GROUPV2_TYPE = 2500,
    /**
     * @generated from protobuf enum value: GROUPV2_TAXED_OPERATION_IDENTIFIER = 2502;
     */
    GROUPV2_TAXED_OPERATION_IDENTIFIER = 2502,
    /**
     * @generated from protobuf enum value: GROUPV2_CLERK = 2504;
     */
    GROUPV2_CLERK = 2504,
    /**
     * @generated from protobuf enum value: GROUPV2_TAXED_LOCATION = 2505;
     */
    GROUPV2_TAXED_LOCATION = 2505,
    /**
     * @generated from protobuf enum value: GROUPV2_TAXED_LOCATION_NAME = 2506;
     */
    GROUPV2_TAXED_LOCATION_NAME = 2506,
    /**
     * @generated from protobuf enum value: GROUPV2_TAXED_LOCATION_PREFIX = 2507;
     */
    GROUPV2_TAXED_LOCATION_PREFIX = 2507,
    /**
     * @generated from protobuf enum value: GROUPV2_CURRENT_LOCATION = 2508;
     */
    GROUPV2_CURRENT_LOCATION = 2508,
    /**
     * @generated from protobuf enum value: GROUPV2_CURRENT_SALE = 2509;
     */
    GROUPV2_CURRENT_SALE = 2509,
    /**
     * @generated from protobuf enum value: GROUPV2_TAXED_SALE = 2510;
     */
    GROUPV2_TAXED_SALE = 2510,
    /**
     * @generated from protobuf enum value: GROUPV2_APPLIED_TAX_RATE = 2511;
     */
    GROUPV2_APPLIED_TAX_RATE = 2511,
    /**
     * labels: shipment products
     *
     * @generated from protobuf enum value: GROUPV2_SHIPMENT_PRODUCTS_ADDITIONAL_FEE_NAME = 2600;
     */
    GROUPV2_SHIPMENT_PRODUCTS_ADDITIONAL_FEE_NAME = 2600,
    /**
     * @generated from protobuf enum value: GROUPV2_SHIPMENT_PRODUCTS_IS_SPECIAL_ORDER = 2601;
     */
    GROUPV2_SHIPMENT_PRODUCTS_IS_SPECIAL_ORDER = 2601,
    /**
     * labels: order shipment
     *
     * @generated from protobuf enum value: GROUPV2_ORDER_SHIPMENT = 2700;
     */
    GROUPV2_ORDER_SHIPMENT = 2700,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER_SHIPMENT_CREATED_AT = 2701;
     */
    GROUPV2_ORDER_SHIPMENT_CREATED_AT = 2701,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER_SHIPMENT_CREATED_BY = 2702;
     */
    GROUPV2_ORDER_SHIPMENT_CREATED_BY = 2702,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER_SHIPMENT_RECEVED_AT = 2703;
     */
    GROUPV2_ORDER_SHIPMENT_RECEVED_AT = 2703,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER_SHIPMENT_NOTES = 2704;
     */
    GROUPV2_ORDER_SHIPMENT_NOTES = 2704,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER_SHIPMENT_MARKED_PAID_AT = 2705;
     */
    GROUPV2_ORDER_SHIPMENT_MARKED_PAID_AT = 2705,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER_SHIPMENT_MARKED_PAID_BY = 2706;
     */
    GROUPV2_ORDER_SHIPMENT_MARKED_PAID_BY = 2706,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER_SHIPMENT_STATUS = 2707;
     */
    GROUPV2_ORDER_SHIPMENT_STATUS = 2707,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER_SHIPMENT_PAY_TO = 2708;
     */
    GROUPV2_ORDER_SHIPMENT_PAY_TO = 2708,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER_SHIPMENT_INVOICE_DATE = 2709;
     */
    GROUPV2_ORDER_SHIPMENT_INVOICE_DATE = 2709,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER_SHIPMENT_INVOICE_DUE_DATE = 2710;
     */
    GROUPV2_ORDER_SHIPMENT_INVOICE_DUE_DATE = 2710,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER_SHIPMENT_INVOICE_NUMBER = 2711;
     */
    GROUPV2_ORDER_SHIPMENT_INVOICE_NUMBER = 2711,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER_SHIPMENT_VOUCHERED_AT = 2712;
     */
    GROUPV2_ORDER_SHIPMENT_VOUCHERED_AT = 2712,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER_SHIPMENT_VOUCHERED_BY = 2713;
     */
    GROUPV2_ORDER_SHIPMENT_VOUCHERED_BY = 2713,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER_SHIPMENT_DROPSHIP_ADDRESS = 2714;
     */
    GROUPV2_ORDER_SHIPMENT_DROPSHIP_ADDRESS = 2714,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER_SHIPMENT_DROPSHIP_RECIPIENT = 2715;
     */
    GROUPV2_ORDER_SHIPMENT_DROPSHIP_RECIPIENT = 2715,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER_SHIPMENT_SCHEDULED_DELIVERY_AT = 2716;
     */
    GROUPV2_ORDER_SHIPMENT_SCHEDULED_DELIVERY_AT = 2716,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER_SHIPMENT_VOUCHERED_DATE = 2717;
     */
    GROUPV2_ORDER_SHIPMENT_VOUCHERED_DATE = 2717,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER_SHIPMENT_INVOICE_REFERENCE_NUMBER = 2718;
     */
    GROUPV2_ORDER_SHIPMENT_INVOICE_REFERENCE_NUMBER = 2718,
    /**
     * labels: aging detail
     *
     * Invoice, Finance charge, credits
     *
     * @generated from protobuf enum value: GROUPV2_AGING_DETAIL_TYPE = 2900;
     */
    GROUPV2_AGING_DETAIL_TYPE = 2900,
    /**
     * 1-30, 31-60, 61+
     *
     * @generated from protobuf enum value: GROUPV2_AGING_DETAIL_STATUS = 2901;
     */
    GROUPV2_AGING_DETAIL_STATUS = 2901,
    /**
     * @generated from protobuf enum value: GROUPV2_AGING_DETAIL_DUE_DATE = 2902;
     */
    GROUPV2_AGING_DETAIL_DUE_DATE = 2902,
    /**
     * labels: product cost
     *
     * @generated from protobuf enum value: GROUPV2_PRODUCT_COST_IS_DEFAULT = 3000;
     */
    GROUPV2_PRODUCT_COST_IS_DEFAULT = 3000,
    /**
     * labels: payment adjustments
     *
     * original invoice date
     *
     * @generated from protobuf enum value: GROUPV2_PAYMENT_ADJUSTMENT__ORIGINAL_DATE = 3100;
     */
    GROUPV2_PAYMENT_ADJUSTMENT__ORIGINAL_DATE = 3100,
    /**
     * Original invoice being adjusted
     *
     * @generated from protobuf enum value: GROUPV2_PAYMENT_ADJUSTMENT__ORIGINAL_TRANSACTION = 3101;
     */
    GROUPV2_PAYMENT_ADJUSTMENT__ORIGINAL_TRANSACTION = 3101,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSFER_PRODUCT__HAS_DISCREPANCY = 3200;
     */
    GROUPV2_TRANSFER_PRODUCT__HAS_DISCREPANCY = 3200,
    /**
     * labels: tag
     *
     * @generated from protobuf enum value: GROUPV2_TAG_NAME = 3300;
     */
    GROUPV2_TAG_NAME = 3300,
    /**
     * @generated from protobuf enum value: GROUPV2_TAG_CREATED_AT = 3301;
     */
    GROUPV2_TAG_CREATED_AT = 3301,
    /**
     * @generated from protobuf enum value: GROUPV2_TAG_TYPE = 3302;
     */
    GROUPV2_TAG_TYPE = 3302,
    /**
     * @generated from protobuf enum value: GROUPV2_TAG_COLOR = 3303;
     */
    GROUPV2_TAG_COLOR = 3303,
    /**
     * labels: staff
     *
     * @generated from protobuf enum value: GROUPV2_STAFF = 3400;
     */
    GROUPV2_STAFF = 3400,
    /**
     * @generated from protobuf enum value: GROUPV2_STAFF_NAME = 3401;
     */
    GROUPV2_STAFF_NAME = 3401,
    /**
     * @generated from protobuf enum value: GROUPV2_STAFF_ROLES = 3402;
     */
    GROUPV2_STAFF_ROLES = 3402,
    /**
     * @generated from protobuf enum value: GROUPV2_STAFF_EMAIL = 3403;
     */
    GROUPV2_STAFF_EMAIL = 3403,
    /**
     * @generated from protobuf enum value: GROUPV2_STAFF_PHONE = 3404;
     */
    GROUPV2_STAFF_PHONE = 3404,
    /**
     * @generated from protobuf enum value: GROUPV2_STAFF_CODE = 3405;
     */
    GROUPV2_STAFF_CODE = 3405,
    /**
     * @generated from protobuf enum value: GROUPV2_STAFF_CREATED_AT = 3406;
     */
    GROUPV2_STAFF_CREATED_AT = 3406,
    /**
     * labels: product pricing tiers
     *
     * @generated from protobuf enum value: GROUPV2_PRODUCT_PRICING_TIER_NAME = 3500;
     */
    GROUPV2_PRODUCT_PRICING_TIER_NAME = 3500,
    /**
     * @generated from protobuf enum value: GROUPV2_PRODUCT_PRICING_TIER_IS_RULE_BASED = 3501;
     */
    GROUPV2_PRODUCT_PRICING_TIER_IS_RULE_BASED = 3501,
    /**
     * @generated from protobuf enum value: GROUPV2_PRODUCT_PRICING_TIER_RANK = 3502;
     */
    GROUPV2_PRODUCT_PRICING_TIER_RANK = 3502,
    /**
     * labels: price rules
     *
     * @generated from protobuf enum value: GROUPV2_PRICE_RULE_NAME = 3600;
     */
    GROUPV2_PRICE_RULE_NAME = 3600,
    /**
     * @generated from protobuf enum value: GROUPV2_PRICE_RULE_TIER_TYPE = 3601;
     */
    GROUPV2_PRICE_RULE_TIER_TYPE = 3601,
    /**
     * @generated from protobuf enum value: GROUPV2_PRICE_RULE_PRICE_STRATEGY = 3602;
     */
    GROUPV2_PRICE_RULE_PRICE_STRATEGY = 3602,
    /**
     * @generated from protobuf enum value: GROUPV2_PRICE_RULE_TYPE = 3603;
     */
    GROUPV2_PRICE_RULE_TYPE = 3603,
    /**
     * @generated from protobuf enum value: GROUPV2_PRICE_RULE_CREATED_AT = 3604;
     */
    GROUPV2_PRICE_RULE_CREATED_AT = 3604,
    /**
     * @generated from protobuf enum value: GROUPV2_PRICE_RULE_FIXED_PRICE = 3605;
     */
    GROUPV2_PRICE_RULE_FIXED_PRICE = 3605,
    /**
     * @generated from protobuf enum value: GROUPV2_PRICE_RULE_MARGIN_PERCENT = 3606;
     */
    GROUPV2_PRICE_RULE_MARGIN_PERCENT = 3606,
    /**
     * @generated from protobuf enum value: GROUPV2_PRICE_RULE_DISCOUNT_PERCENT = 3607;
     */
    GROUPV2_PRICE_RULE_DISCOUNT_PERCENT = 3607,
    /**
     * @generated from protobuf enum value: GROUPV2_PRICE_RULE_PRODUCT = 3608;
     */
    GROUPV2_PRICE_RULE_PRODUCT = 3608,
    /**
     * @generated from protobuf enum value: GROUPV2_PRICE_RULE_PRODUCT_CATEGORY = 3609;
     */
    GROUPV2_PRICE_RULE_PRODUCT_CATEGORY = 3609,
    /**
     * @generated from protobuf enum value: GROUPV2_PRICE_RULE_TIER_RANK = 3610;
     */
    GROUPV2_PRICE_RULE_TIER_RANK = 3610,
    /**
     * @generated from protobuf enum value: GROUPV2_PRICE_RULE_TIER_NAME = 3611;
     */
    GROUPV2_PRICE_RULE_TIER_NAME = 3611,
    /**
     * @generated from protobuf enum value: GROUPV2_PRICE_RULE_IS_PRICE_ROUNDED_UP = 3612;
     */
    GROUPV2_PRICE_RULE_IS_PRICE_ROUNDED_UP = 3612,
    /**
     * @generated from protobuf enum value: GROUPV2_PRICE_RULE_PRICE_ROUNDING_TYPE = 3613;
     */
    GROUPV2_PRICE_RULE_PRICE_ROUNDING_TYPE = 3613,
    /**
     * labels: spiffs
     *
     * @generated from protobuf enum value: GROUPV2_SPIFF_NAME = 3700;
     */
    GROUPV2_SPIFF_NAME = 3700,
    /**
     * @generated from protobuf enum value: GROUPV2_SPIFF_CREATED_BY = 3701;
     */
    GROUPV2_SPIFF_CREATED_BY = 3701,
    /**
     * @generated from protobuf enum value: GROUPV2_SPIFF_CREATED_AT = 3702;
     */
    GROUPV2_SPIFF_CREATED_AT = 3702,
    /**
     * @generated from protobuf enum value: GROUPV2_SPIFF_STARTS_AT = 3703;
     */
    GROUPV2_SPIFF_STARTS_AT = 3703,
    /**
     * @generated from protobuf enum value: GROUPV2_SPIFF_EXPIRES_AT = 3704;
     */
    GROUPV2_SPIFF_EXPIRES_AT = 3704,
    /**
     * @generated from protobuf enum value: GROUPV2_SPIFF_ORIGINAL_SALE_CLERK = 3705;
     */
    GROUPV2_SPIFF_ORIGINAL_SALE_CLERK = 3705,
    /**
     * labels: gift card balances
     *
     * @generated from protobuf enum value: GROUPV2_GIFT_CARD_ACTIVATION_DATE = 3800;
     */
    GROUPV2_GIFT_CARD_ACTIVATION_DATE = 3800,
    /**
     * @generated from protobuf enum value: GROUPV2_GIFT_CARD_PRODUCT = 3801;
     */
    GROUPV2_GIFT_CARD_PRODUCT = 3801,
    /**
     * @generated from protobuf enum value: GROUPV2_GIFT_CARD_STATUS = 3802;
     */
    GROUPV2_GIFT_CARD_STATUS = 3802,
    /**
     * labels: routines
     *
     * @generated from protobuf enum value: GROUPV2_ROUTINE = 4000;
     */
    GROUPV2_ROUTINE = 4000,
    /**
     * @generated from protobuf enum value: GROUPV2_ROUTINE_NAME = 4001;
     */
    GROUPV2_ROUTINE_NAME = 4001,
    /**
     * @generated from protobuf enum value: GROUPV2_ROUTINE_PROMPT = 4002;
     */
    GROUPV2_ROUTINE_PROMPT = 4002,
    /**
     * @generated from protobuf enum value: GROUPV2_ROUTINE_LAST_RUN_AT = 4003;
     */
    GROUPV2_ROUTINE_LAST_RUN_AT = 4003,
    /**
     * @generated from protobuf enum value: GROUPV2_ROUTINE_NEXT_SCHEDULED_RUN = 4004;
     */
    GROUPV2_ROUTINE_NEXT_SCHEDULED_RUN = 4004,
    /**
     * labels: company
     *
     * @generated from protobuf enum value: GROUPV2_COMPANY_NAME = 4099;
     */
    GROUPV2_COMPANY_NAME = 4099,
    /**
     * @generated from protobuf enum value: GROUPV2_COMPANY_IS_BENJAMIN_MOORE_SUPPLIER = 4100;
     */
    GROUPV2_COMPANY_IS_BENJAMIN_MOORE_SUPPLIER = 4100,
    /**
     * @generated from protobuf enum value: GROUPV2_COMPANY_IS_NEP_CLIENT = 4101;
     */
    GROUPV2_COMPANY_IS_NEP_CLIENT = 4101,
    /**
     * @generated from protobuf enum value: GROUPV2_COMPANY_SHOULD_AUTO_SUBMIT_CCP_REWARDS = 4102;
     */
    GROUPV2_COMPANY_SHOULD_AUTO_SUBMIT_CCP_REWARDS = 4102,
    /**
     * @generated from protobuf enum value: GROUPV2_COMPANY_SHOULD_AUTO_SUBMIT_CONTRACTOR_REWARDS = 4103;
     */
    GROUPV2_COMPANY_SHOULD_AUTO_SUBMIT_CONTRACTOR_REWARDS = 4103,
    /**
     * @generated from protobuf enum value: GROUPV2_COMPANY_CONTRACTOR_REWARDS_BONUS_CODE = 4104;
     */
    GROUPV2_COMPANY_CONTRACTOR_REWARDS_BONUS_CODE = 4104,
    /**
     * @generated from protobuf enum value: GROUPV2_COMPANY_ACTIVATED_AT = 4105;
     */
    GROUPV2_COMPANY_ACTIVATED_AT = 4105,
    /**
     * @generated from protobuf enum value: GROUPV2_COMPANY_IS_ACTIVE = 4106;
     */
    GROUPV2_COMPANY_IS_ACTIVE = 4106,
    /**
     * labels: deliveries
     *
     * @generated from protobuf enum value: GROUPV2_DELIVERY = 4200;
     */
    GROUPV2_DELIVERY = 4200,
    /**
     * @generated from protobuf enum value: GROUPV2_DELIVERY_STATUS = 4201;
     */
    GROUPV2_DELIVERY_STATUS = 4201,
    /**
     * @generated from protobuf enum value: GROUPV2_DELIVERY_DEPARTURE_TIME = 4202;
     */
    GROUPV2_DELIVERY_DEPARTURE_TIME = 4202,
    /**
     * @generated from protobuf enum value: GROUPV2_DELIVERY_DEPARTURE_DATE = 4203;
     */
    GROUPV2_DELIVERY_DEPARTURE_DATE = 4203,
    /**
     * @generated from protobuf enum value: GROUPV2_DELIVERY_RETURN_TIME = 4204;
     */
    GROUPV2_DELIVERY_RETURN_TIME = 4204,
    /**
     * @generated from protobuf enum value: GROUPV2_DELIVERY_CARRIER = 4205;
     */
    GROUPV2_DELIVERY_CARRIER = 4205,
    /**
     * @generated from protobuf enum value: GROUPV2_DELIVERY_DRIVER = 4206;
     */
    GROUPV2_DELIVERY_DRIVER = 4206,
    /**
     * @generated from protobuf enum value: GROUPV2_DELIVERY_NOTES = 4207;
     */
    GROUPV2_DELIVERY_NOTES = 4207,
    /**
     * @generated from protobuf enum value: GROUPV2_DELIVERY_INTERNAL_NOTES = 4208;
     */
    GROUPV2_DELIVERY_INTERNAL_NOTES = 4208,
    /**
     * @generated from protobuf enum value: GROUPV2_DELIVERY_CREATED_AT = 4209;
     */
    GROUPV2_DELIVERY_CREATED_AT = 4209,
    /**
     * @generated from protobuf enum value: GROUPV2_DELIVERY_CREATED_BY = 4210;
     */
    GROUPV2_DELIVERY_CREATED_BY = 4210,
    /**
     * @generated from protobuf enum value: GROUPV2_DELIVERY_CUSTOMERS = 4214;
     */
    GROUPV2_DELIVERY_CUSTOMERS = 4214,
    /**
     * @generated from protobuf enum value: GROUPV2_DELIVERY_SALES = 4215;
     */
    GROUPV2_DELIVERY_SALES = 4215,
    /**
     * @generated from protobuf enum value: GROUPV2_SINGLE_ENTRY__ACCOUNT_NAME = 3900;
     */
    GROUPV2_SINGLE_ENTRY__ACCOUNT_NAME = 3900,
    /**
     * @generated from protobuf enum value: GROUPV2_SINGLE_ENTRY__ACCOUNT_NUMBER = 3901;
     */
    GROUPV2_SINGLE_ENTRY__ACCOUNT_NUMBER = 3901,
    /**
     * @generated from protobuf enum value: GROUPV2_SINGLE_ENTRY__ACCOUNT_TYPE = 3902;
     */
    GROUPV2_SINGLE_ENTRY__ACCOUNT_TYPE = 3902,
    /**
     * @generated from protobuf enum value: GROUPV2_SINGLE_ENTRY__CONTROL_ACCOUNT = 3903;
     */
    GROUPV2_SINGLE_ENTRY__CONTROL_ACCOUNT = 3903,
    /**
     * @generated from protobuf enum value: GROUPV2_SINGLE_ENTRY__CONTROL_ACCOUNT_DESCRIPTION = 3904;
     */
    GROUPV2_SINGLE_ENTRY__CONTROL_ACCOUNT_DESCRIPTION = 3904,
    /**
     * @generated from protobuf enum value: GROUPV2_SINGLE_ENTRY__CONTROL_TYPE = 3905;
     */
    GROUPV2_SINGLE_ENTRY__CONTROL_TYPE = 3905,
    /**
     * metrics: general
     *
     * @generated from protobuf enum value: GROUPV2_ROW_COUNT = 10001;
     */
    GROUPV2_ROW_COUNT = 10001,
    /**
     * metrics: product
     *
     * @generated from protobuf enum value: GROUPV2_PRODUCT_LOCATION_ON_HAND_QTY = 10200;
     */
    GROUPV2_PRODUCT_LOCATION_ON_HAND_QTY = 10200,
    /**
     * @generated from protobuf enum value: GROUPV2_PRODUCT_LOCATION_COMMITTED_QTY = 10201;
     */
    GROUPV2_PRODUCT_LOCATION_COMMITTED_QTY = 10201,
    /**
     * @generated from protobuf enum value: GROUPV2_PRODUCT_LOCATION_ON_ORDER_QTY = 10202;
     */
    GROUPV2_PRODUCT_LOCATION_ON_ORDER_QTY = 10202,
    /**
     * @generated from protobuf enum value: GROUPV2_PRODUCT_LOCATION_COMMITTED_VALUE = 10203;
     */
    GROUPV2_PRODUCT_LOCATION_COMMITTED_VALUE = 10203,
    /**
     * @generated from protobuf enum value: GROUPV2_PRODUCT_LOCATION_ON_ORDER_VALUE = 10204;
     */
    GROUPV2_PRODUCT_LOCATION_ON_ORDER_VALUE = 10204,
    /**
     * @generated from protobuf enum value: GROUPV2_PRODUCT_LOCATION_ON_HAND_VALUE = 10205;
     */
    GROUPV2_PRODUCT_LOCATION_ON_HAND_VALUE = 10205,
    /**
     * @generated from protobuf enum value: GROUPV2_PRODUCT_ADDITIONAL_COSTS = 10206;
     */
    GROUPV2_PRODUCT_ADDITIONAL_COSTS = 10206,
    /**
     * @generated from protobuf enum value: GROUPV2_PRODUCT_GLOBAL_ON_HAND_QTY = 10207;
     */
    GROUPV2_PRODUCT_GLOBAL_ON_HAND_QTY = 10207,
    /**
     * @generated from protobuf enum value: GROUPV2_PRODUCT_GLOBAL_ON_ORDER_QTY = 10208;
     */
    GROUPV2_PRODUCT_GLOBAL_ON_ORDER_QTY = 10208,
    /**
     * @generated from protobuf enum value: GROUPV2_PRODUCT_CURRENT_STOCK_QTY = 10209;
     */
    GROUPV2_PRODUCT_CURRENT_STOCK_QTY = 10209,
    /**
     * @generated from protobuf enum value: GROUPV2_PRODUCT_CURRENT_STOCK_VALUE = 10210;
     */
    GROUPV2_PRODUCT_CURRENT_STOCK_VALUE = 10210,
    /**
     * @generated from protobuf enum value: GROUPV2_PRODUCT_DEFAULT_VENDOR_COST = 10211;
     */
    GROUPV2_PRODUCT_DEFAULT_VENDOR_COST = 10211,
    /**
     * @generated from protobuf enum value: GROUPV2_PRODUCT_STANDARD_COST = 10212;
     */
    GROUPV2_PRODUCT_STANDARD_COST = 10212,
    /**
     * @generated from protobuf enum value: GROUPV2_PRODUCT_AVERAGE_COST = 10213;
     */
    GROUPV2_PRODUCT_AVERAGE_COST = 10213,
    /**
     * @generated from protobuf enum value: GROUPV2_PRODUCT_CURRENT_ON_HAND_STANDARD_VALUE = 10214;
     */
    GROUPV2_PRODUCT_CURRENT_ON_HAND_STANDARD_VALUE = 10214,
    /**
     * @generated from protobuf enum value: GROUPV2_PRODUCT_CURRENT_COMMITTED_STANDARD_VALUE = 10215;
     */
    GROUPV2_PRODUCT_CURRENT_COMMITTED_STANDARD_VALUE = 10215,
    /**
     * @generated from protobuf enum value: GROUPV2_PRODUCT_CURRENT_ON_ORDER_STANDARD_VALUE = 10216;
     */
    GROUPV2_PRODUCT_CURRENT_ON_ORDER_STANDARD_VALUE = 10216,
    /**
     * @generated from protobuf enum value: GROUPV2_PRODUCT_CURRENT_STOCK_STANDARD_VALUE = 10217;
     */
    GROUPV2_PRODUCT_CURRENT_STOCK_STANDARD_VALUE = 10217,
    /**
     * metrics: customer
     *
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_BALANCE_TOTAL = 10300;
     */
    GROUPV2_CUSTOMER_BALANCE_TOTAL = 10300,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_BALANCE_CURRENT = 10301;
     */
    GROUPV2_CUSTOMER_BALANCE_CURRENT = 10301,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_BALANCE_1_30_DAYS = 10302;
     */
    GROUPV2_CUSTOMER_BALANCE_1_30_DAYS = 10302,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_BALANCE_31_60_DAYS = 10303;
     */
    GROUPV2_CUSTOMER_BALANCE_31_60_DAYS = 10303,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_BALANCE_61_PLUS_DAYS = 10304;
     */
    GROUPV2_CUSTOMER_BALANCE_61_PLUS_DAYS = 10304,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_BALANCE_CREDITS = 10305;
     */
    GROUPV2_CUSTOMER_BALANCE_CREDITS = 10305,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_BALANCE_FINANCE_CHARGES = 10306;
     */
    GROUPV2_CUSTOMER_BALANCE_FINANCE_CHARGES = 10306,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_CREDIT_LIMIT = 10307;
     */
    GROUPV2_CUSTOMER_CREDIT_LIMIT = 10307,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_SALES_LAST_12_MO = 10308;
     */
    GROUPV2_CUSTOMER_SALES_LAST_12_MO = 10308,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_SALES_LAST_3_MO = 10309;
     */
    GROUPV2_CUSTOMER_SALES_LAST_3_MO = 10309,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_SALES_LAST_1_MO = 10310;
     */
    GROUPV2_CUSTOMER_SALES_LAST_1_MO = 10310,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_SALES_YTD = 10311;
     */
    GROUPV2_CUSTOMER_SALES_YTD = 10311,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_SALES_LAST_YTD = 10312;
     */
    GROUPV2_CUSTOMER_SALES_LAST_YTD = 10312,
    /**
     * @generated from protobuf enum value: GROUPV2_CUSTOMER_AVERAGE_DAYS_TO_PAY = 10313;
     */
    GROUPV2_CUSTOMER_AVERAGE_DAYS_TO_PAY = 10313,
    /**
     * metrics: sale
     *
     * @generated from protobuf enum value: GROUPV2_SALE_FEES = 10400;
     */
    GROUPV2_SALE_FEES = 10400,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE_BASE_TAX = 10401;
     */
    GROUPV2_SALE_BASE_TAX = 10401,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE_CARD_SURCHARGE = 10402;
     */
    GROUPV2_SALE_CARD_SURCHARGE = 10402,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE_TOTAL = 10403;
     */
    GROUPV2_SALE_TOTAL = 10403,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE_RESTOCK_FEE_AMOUNT = 10404;
     */
    GROUPV2_SALE_RESTOCK_FEE_AMOUNT = 10404,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE_RESTOCK_FEE_APPLIED = 10405;
     */
    GROUPV2_SALE_RESTOCK_FEE_APPLIED = 10405,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE_REVENUE = 10406;
     */
    GROUPV2_SALE_REVENUE = 10406,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE_ADDITIONAL_FEES_NET = 10407;
     */
    GROUPV2_SALE_ADDITIONAL_FEES_NET = 10407,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE_SUBTOTAL_NET = 10408;
     */
    GROUPV2_SALE_SUBTOTAL_NET = 10408,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE_CARD_SURCHARGE_TAX = 10409;
     */
    GROUPV2_SALE_CARD_SURCHARGE_TAX = 10409,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE_TOTAL_NET = 10410;
     */
    GROUPV2_SALE_TOTAL_NET = 10410,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE_ROUNDING_ADJUSTMENT_NET = 10411;
     */
    GROUPV2_SALE_ROUNDING_ADJUSTMENT_NET = 10411,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE_EARLY_PAYMENT_DISCOUNT_ADJUSTMENT_NET = 10412;
     */
    GROUPV2_SALE_EARLY_PAYMENT_DISCOUNT_ADJUSTMENT_NET = 10412,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE_SUBTOTAL = 10413;
     */
    GROUPV2_SALE_SUBTOTAL = 10413,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE_ROUNDING_ADJUSTMENT = 10414;
     */
    GROUPV2_SALE_ROUNDING_ADJUSTMENT = 10414,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE_EARLY_PAYMENT_DISCOUNT_ADJUSTMENT = 10415;
     */
    GROUPV2_SALE_EARLY_PAYMENT_DISCOUNT_ADJUSTMENT = 10415,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE__SALES_TAX_NET = 10416;
     */
    GROUPV2_SALE__SALES_TAX_NET = 10416,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE__SALES_TAX = 10417;
     */
    GROUPV2_SALE__SALES_TAX = 10417,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE_RESTOCK_FEE = 10418;
     */
    GROUPV2_SALE_RESTOCK_FEE = 10418,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE_BASE_TAX_NET = 10419;
     */
    GROUPV2_SALE_BASE_TAX_NET = 10419,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE_CARD_SURCHARGE_NET = 10420;
     */
    GROUPV2_SALE_CARD_SURCHARGE_NET = 10420,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE_CARD_SURCHARGE_TAX_NET = 10421;
     */
    GROUPV2_SALE_CARD_SURCHARGE_TAX_NET = 10421,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE_RESTOCK_FEE_NET = 10422;
     */
    GROUPV2_SALE_RESTOCK_FEE_NET = 10422,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE_CARD_FEES = 10423;
     */
    GROUPV2_SALE_CARD_FEES = 10423,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE_DISCOUNT_REVENUE = 10424;
     */
    GROUPV2_SALE_DISCOUNT_REVENUE = 10424,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE_REVENUE_NET = 10425;
     */
    GROUPV2_SALE_REVENUE_NET = 10425,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE_CASH_ROUNDING_DELTA = 10426;
     */
    GROUPV2_SALE_CASH_ROUNDING_DELTA = 10426,
    /**
     * @generated from protobuf enum value: GROUPV2_SALE_CASH_ROUNDING_DELTA_NET = 10427;
     */
    GROUPV2_SALE_CASH_ROUNDING_DELTA_NET = 10427,
    /**
     * metrics: sold product
     *
     * @generated from protobuf enum value: GROUPV2_SOLD_PRODUCT_REVENUE_NET = 10500;
     */
    GROUPV2_SOLD_PRODUCT_REVENUE_NET = 10500,
    /**
     * @generated from protobuf enum value: GROUPV2_SOLD_PRODUCT_REVENUE_SOLD = 10501;
     */
    GROUPV2_SOLD_PRODUCT_REVENUE_SOLD = 10501,
    /**
     * @generated from protobuf enum value: GROUPV2_SOLD_PRODUCT_REVENUE_RETURNED = 10502;
     */
    GROUPV2_SOLD_PRODUCT_REVENUE_RETURNED = 10502,
    /**
     * @generated from protobuf enum value: GROUPV2_SOLD_PRODUCT_PROFIT_SOLD = 10504;
     */
    GROUPV2_SOLD_PRODUCT_PROFIT_SOLD = 10504,
    /**
     * @generated from protobuf enum value: GROUPV2_SOLD_PRODUCT_PROFIT_RETURNED = 10505;
     */
    GROUPV2_SOLD_PRODUCT_PROFIT_RETURNED = 10505,
    /**
     * @generated from protobuf enum value: GROUPV2_SOLD_PRODUCT_COST_SOLD = 10507;
     */
    GROUPV2_SOLD_PRODUCT_COST_SOLD = 10507,
    /**
     * @generated from protobuf enum value: GROUPV2_SOLD_PRODUCT_COST_RETURNED = 10508;
     */
    GROUPV2_SOLD_PRODUCT_COST_RETURNED = 10508,
    /**
     * @generated from protobuf enum value: GROUPV2_SOLD_PRODUCT_QUANTITY_SOLD_NET = 10509;
     */
    GROUPV2_SOLD_PRODUCT_QUANTITY_SOLD_NET = 10509,
    /**
     * @generated from protobuf enum value: GROUPV2_SOLD_PRODUCT_QUANTITY_SOLD = 10510;
     */
    GROUPV2_SOLD_PRODUCT_QUANTITY_SOLD = 10510,
    /**
     * @generated from protobuf enum value: GROUPV2_SOLD_PRODUCT_QUANTITY_RETURNED = 10511;
     */
    GROUPV2_SOLD_PRODUCT_QUANTITY_RETURNED = 10511,
    /**
     * @generated from protobuf enum value: GROUPV2_SOLD_PRODUCT_ADDITIONAL_FEES = 10512;
     */
    GROUPV2_SOLD_PRODUCT_ADDITIONAL_FEES = 10512,
    /**
     * @generated from protobuf enum value: GROUPV2_SOLD_PRODUCT_SALE_PRICE = 10513;
     */
    GROUPV2_SOLD_PRODUCT_SALE_PRICE = 10513,
    /**
     * cost net
     *
     * @generated from protobuf enum value: GROUPV2_SOLD_PRODUCT_COGS = 10514;
     */
    GROUPV2_SOLD_PRODUCT_COGS = 10514,
    /**
     * @generated from protobuf enum value: GROUPV2_SOLD_PRODUCT_GROSS_PROFIT = 10515;
     */
    GROUPV2_SOLD_PRODUCT_GROSS_PROFIT = 10515,
    /**
     * @generated from protobuf enum value: GROUPV2_SOLD_PRODUCT_GROSS_MARGIN = 10516;
     */
    GROUPV2_SOLD_PRODUCT_GROSS_MARGIN = 10516,
    /**
     * @generated from protobuf enum value: GROUPV2_SOLD_PRODUCT_TAX = 10519;
     */
    GROUPV2_SOLD_PRODUCT_TAX = 10519,
    /**
     * pre-edit price from pricing rules
     *
     * @generated from protobuf enum value: GROUPV2_SOLD_PRODUCT_STANDARD_PRICE = 10520;
     */
    GROUPV2_SOLD_PRODUCT_STANDARD_PRICE = 10520,
    /**
     * @generated from protobuf enum value: GROUPV2_SOLD_PRODUCT_PRICE_EDIT_IMPACT = 10521;
     */
    GROUPV2_SOLD_PRODUCT_PRICE_EDIT_IMPACT = 10521,
    /**
     * proportionally allocated from sale
     *
     * @generated from protobuf enum value: GROUPV2_SOLD_PRODUCT_CARD_FEES = 10522;
     */
    GROUPV2_SOLD_PRODUCT_CARD_FEES = 10522,
    /**
     * @generated from protobuf enum value: GROUPV2_SOLD_PRODUCT_CARD_SURCHARGE = 10523;
     */
    GROUPV2_SOLD_PRODUCT_CARD_SURCHARGE = 10523,
    /**
     * @generated from protobuf enum value: GROUPV2_SOLD_PRODUCT_RESTOCK_FEE = 10525;
     */
    GROUPV2_SOLD_PRODUCT_RESTOCK_FEE = 10525,
    /**
     * metrics: order
     *
     * @generated from protobuf enum value: GROUPV2_ORDER_TOTAL_COST = 11100;
     */
    GROUPV2_ORDER_TOTAL_COST = 11100,
    /**
     * metrics: transfers
     *
     * @generated from protobuf enum value: GROUPV2_TRANSFER_PRODUCT_TOTAL_COST = 11200;
     */
    GROUPV2_TRANSFER_PRODUCT_TOTAL_COST = 11200,
    /**
     * metrics: transaction
     *
     * @generated from protobuf enum value: GROUPV2_TRANSACTION__AMOUNT = 11470;
     */
    GROUPV2_TRANSACTION__AMOUNT = 11470,
    /**
     * @generated from protobuf enum value: GROUPV2_GIFT_CARD_TRANSACTION_AMOUNT = 11471;
     */
    GROUPV2_GIFT_CARD_TRANSACTION_AMOUNT = 11471,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSACTION__UNIT_COST = 11472;
     */
    GROUPV2_TRANSACTION__UNIT_COST = 11472,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSACTION__UNIT_COST_DELTA = 11473;
     */
    GROUPV2_TRANSACTION__UNIT_COST_DELTA = 11473,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSACTION__ON_HAND_DELTA = 11474;
     */
    GROUPV2_TRANSACTION__ON_HAND_DELTA = 11474,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSACTION__LOCATION_RUNNING_ON_HAND = 11475;
     */
    GROUPV2_TRANSACTION__LOCATION_RUNNING_ON_HAND = 11475,
    /**
     * global
     *
     * @generated from protobuf enum value: GROUPV2_TRANSACTION__RUNNING_ON_HAND = 11476;
     */
    GROUPV2_TRANSACTION__RUNNING_ON_HAND = 11476,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSACTION__COMMITTED_DELTA = 11477;
     */
    GROUPV2_TRANSACTION__COMMITTED_DELTA = 11477,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSACTION__LOCATION_RUNNING_COMMITTED = 11478;
     */
    GROUPV2_TRANSACTION__LOCATION_RUNNING_COMMITTED = 11478,
    /**
     * global
     *
     * @generated from protobuf enum value: GROUPV2_TRANSACTION__RUNNING_COMMITTED = 11479;
     */
    GROUPV2_TRANSACTION__RUNNING_COMMITTED = 11479,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSACTION__ON_ORDER_DELTA = 11480;
     */
    GROUPV2_TRANSACTION__ON_ORDER_DELTA = 11480,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSACTION__LOCATION_RUNNING_ON_ORDER = 11481;
     */
    GROUPV2_TRANSACTION__LOCATION_RUNNING_ON_ORDER = 11481,
    /**
     * global
     *
     * @generated from protobuf enum value: GROUPV2_TRANSACTION__RUNNING_ON_ORDER = 11482;
     */
    GROUPV2_TRANSACTION__RUNNING_ON_ORDER = 11482,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSACTION__STOCK_DELTA = 11483;
     */
    GROUPV2_TRANSACTION__STOCK_DELTA = 11483,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSACTION__LOCATION_RUNNING_STOCK = 11484;
     */
    GROUPV2_TRANSACTION__LOCATION_RUNNING_STOCK = 11484,
    /**
     * global
     *
     * @generated from protobuf enum value: GROUPV2_TRANSACTION__RUNNING_STOCK = 11485;
     */
    GROUPV2_TRANSACTION__RUNNING_STOCK = 11485,
    /**
     * global
     *
     * @generated from protobuf enum value: GROUPV2_TRANSACTION__RUNNING_AVERAGE_COST = 11486;
     */
    GROUPV2_TRANSACTION__RUNNING_AVERAGE_COST = 11486,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSACTION__LOCATION_RUNNING_VALUATION = 11487;
     */
    GROUPV2_TRANSACTION__LOCATION_RUNNING_VALUATION = 11487,
    /**
     * global
     *
     * @generated from protobuf enum value: GROUPV2_TRANSACTION__RUNNING_VALUATION = 11488;
     */
    GROUPV2_TRANSACTION__RUNNING_VALUATION = 11488,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSACTION__SUBTOTAL = 11489;
     */
    GROUPV2_TRANSACTION__SUBTOTAL = 11489,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSACTION__SALES_TAX = 11490;
     */
    GROUPV2_TRANSACTION__SALES_TAX = 11490,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSACTION__LEDGER_VALUATION_DELTA = 11491;
     */
    GROUPV2_TRANSACTION__LEDGER_VALUATION_DELTA = 11491,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSACTION__LOYALTY_POINTS = 11492;
     */
    GROUPV2_TRANSACTION__LOYALTY_POINTS = 11492,
    /**
     * metrics: transaction payment
     *
     * @generated from protobuf enum value: GROUPV2_PAYMENT_CASH_RECEIVED = 11571;
     */
    GROUPV2_PAYMENT_CASH_RECEIVED = 11571,
    /**
     * @generated from protobuf enum value: GROUPV2_PAYMENT_CHANGE_GIVEN = 11572;
     */
    GROUPV2_PAYMENT_CHANGE_GIVEN = 11572,
    /**
     * @generated from protobuf enum value: GROUPV2_PAYMENT_PROCESSING_FEES = 11573;
     */
    GROUPV2_PAYMENT_PROCESSING_FEES = 11573,
    /**
     * @generated from protobuf enum value: GROUPV2_PAYMENT_FC_ALLOCATION = 11574;
     */
    GROUPV2_PAYMENT_FC_ALLOCATION = 11574,
    /**
     * @generated from protobuf enum value: GROUPV2_PAYMENT__TOTAL_FC_ALLOCATION = 11575;
     */
    GROUPV2_PAYMENT__TOTAL_FC_ALLOCATION = 11575,
    /**
     * @generated from protobuf enum value: GROUPV2_PAYMENT_SURCHARGE = 11576;
     */
    GROUPV2_PAYMENT_SURCHARGE = 11576,
    /**
     * @generated from protobuf enum value: GROUPV2_PAYMENT_SURCHARGE_TAX = 11577;
     */
    GROUPV2_PAYMENT_SURCHARGE_TAX = 11577,
    /**
     * @generated from protobuf enum value: GROUPV2_PAYMENT_PROCESSING_NET = 11578;
     */
    GROUPV2_PAYMENT_PROCESSING_NET = 11578,
    /**
     * @generated from protobuf enum value: GROUPV2_PAYMENT_CASH_ROUNDING_DELTA = 11579;
     */
    GROUPV2_PAYMENT_CASH_ROUNDING_DELTA = 11579,
    /**
     * metrics: counted products
     *
     * @generated from protobuf enum value: GROUPV2_COUNTED_PRODUCTS_EXPECTED = 11700;
     */
    GROUPV2_COUNTED_PRODUCTS_EXPECTED = 11700,
    /**
     * @generated from protobuf enum value: GROUPV2_COUNTED_PRODUCTS_COUNTED = 11701;
     */
    GROUPV2_COUNTED_PRODUCTS_COUNTED = 11701,
    /**
     * @generated from protobuf enum value: GROUPV2_COUNTED_PRODUCTS_VARIANCE = 11702;
     */
    GROUPV2_COUNTED_PRODUCTS_VARIANCE = 11702,
    /**
     * @generated from protobuf enum value: GROUPV2_COUNTED_PRODUCTS_VARIANCE_VALUE = 11703;
     */
    GROUPV2_COUNTED_PRODUCTS_VARIANCE_VALUE = 11703,
    /**
     * @generated from protobuf enum value: GROUPV2_COUNTED_PRODUCTS_EXPECTED_VALUE = 11704;
     */
    GROUPV2_COUNTED_PRODUCTS_EXPECTED_VALUE = 11704,
    /**
     * @generated from protobuf enum value: GROUPV2_COUNTED_PRODUCTS_COUNTED_VALUE = 11705;
     */
    GROUPV2_COUNTED_PRODUCTS_COUNTED_VALUE = 11705,
    /**
     * metrics: finance charge
     *
     * @generated from protobuf enum value: GROUPV2_FINANCE_CHARGE_ASSESSED_BALANCE = 11800;
     */
    GROUPV2_FINANCE_CHARGE_ASSESSED_BALANCE = 11800,
    /**
     * @generated from protobuf enum value: GROUPV2_FINANCE_CHARGE_NEW_BALANCE = 11801;
     */
    GROUPV2_FINANCE_CHARGE_NEW_BALANCE = 11801,
    /**
     * @generated from protobuf enum value: GROUPV2_FINANCE_CHARGE_AMOUNT = 11802;
     */
    GROUPV2_FINANCE_CHARGE_AMOUNT = 11802,
    /**
     * metrics: transfer product
     *
     * @generated from protobuf enum value: GROUPV2_TRANSFER_PRODUCT_QUANTITY_REQUESTED = 12000;
     */
    GROUPV2_TRANSFER_PRODUCT_QUANTITY_REQUESTED = 12000,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSFER_PRODUCT_QUANTITY_SENT = 12001;
     */
    GROUPV2_TRANSFER_PRODUCT_QUANTITY_SENT = 12001,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSFER_PRODUCT_QUANTITY_RECEIVED = 12002;
     */
    GROUPV2_TRANSFER_PRODUCT_QUANTITY_RECEIVED = 12002,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSFER_PRODUCT_VALUE_REQUESTED = 12003;
     */
    GROUPV2_TRANSFER_PRODUCT_VALUE_REQUESTED = 12003,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSFER_PRODUCT_VALUE_SENT = 12004;
     */
    GROUPV2_TRANSFER_PRODUCT_VALUE_SENT = 12004,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSFER_PRODUCT_VALUE_RECEIVED = 12005;
     */
    GROUPV2_TRANSFER_PRODUCT_VALUE_RECEIVED = 12005,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSFER_PRODUCT_QUANTITY_DELTA = 12006;
     */
    GROUPV2_TRANSFER_PRODUCT_QUANTITY_DELTA = 12006,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSFER_PRODUCT_VALUE_DELTA = 12007;
     */
    GROUPV2_TRANSFER_PRODUCT_VALUE_DELTA = 12007,
    /**
     * @generated from protobuf enum value: GROUPV2_TRANSFER_PRODUCT_UNIT_COST = 12008;
     */
    GROUPV2_TRANSFER_PRODUCT_UNIT_COST = 12008,
    /**
     * metrics: transaction close out
     *
     * $0.01
     *
     * @generated from protobuf enum value: GROUPV2_CLOSE_OUT_PENNIES = 12100;
     */
    GROUPV2_CLOSE_OUT_PENNIES = 12100,
    /**
     * $0.05
     *
     * @generated from protobuf enum value: GROUPV2_CLOSE_OUT_NICKELS = 12101;
     */
    GROUPV2_CLOSE_OUT_NICKELS = 12101,
    /**
     * $0.10
     *
     * @generated from protobuf enum value: GROUPV2_CLOSE_OUT_DIMES = 12102;
     */
    GROUPV2_CLOSE_OUT_DIMES = 12102,
    /**
     * $0.25
     *
     * @generated from protobuf enum value: GROUPV2_CLOSE_OUT_QUARTERS = 12103;
     */
    GROUPV2_CLOSE_OUT_QUARTERS = 12103,
    /**
     * $1.00
     *
     * @generated from protobuf enum value: GROUPV2_CLOSE_OUT_ONES = 12104;
     */
    GROUPV2_CLOSE_OUT_ONES = 12104,
    /**
     * $5.00
     *
     * @generated from protobuf enum value: GROUPV2_CLOSE_OUT_FIVES = 12105;
     */
    GROUPV2_CLOSE_OUT_FIVES = 12105,
    /**
     * $10.00
     *
     * @generated from protobuf enum value: GROUPV2_CLOSE_OUT_TENS = 12106;
     */
    GROUPV2_CLOSE_OUT_TENS = 12106,
    /**
     * $20.00
     *
     * @generated from protobuf enum value: GROUPV2_CLOSE_OUT_TWENTIES = 12107;
     */
    GROUPV2_CLOSE_OUT_TWENTIES = 12107,
    /**
     * $50.00
     *
     * @generated from protobuf enum value: GROUPV2_CLOSE_OUT_FIFTIES = 12108;
     */
    GROUPV2_CLOSE_OUT_FIFTIES = 12108,
    /**
     * $100.00
     *
     * @generated from protobuf enum value: GROUPV2_CLOSE_OUT_HUNDREDS = 12109;
     */
    GROUPV2_CLOSE_OUT_HUNDREDS = 12109,
    /**
     * $2.00
     *
     * @generated from protobuf enum value: GROUPV2_CLOSE_OUT_TWOS = 12110;
     */
    GROUPV2_CLOSE_OUT_TWOS = 12110,
    /**
     * metrics: inventory
     *
     * @generated from protobuf enum value: GROUPV2_INVENTORY_ON_HAND = 12200;
     */
    GROUPV2_INVENTORY_ON_HAND = 12200,
    /**
     * @generated from protobuf enum value: GROUPV2_INVENTORY_ON_HAND_VALUE = 12201;
     */
    GROUPV2_INVENTORY_ON_HAND_VALUE = 12201,
    /**
     * @generated from protobuf enum value: GROUPV2_INVENTORY_COMMITTED = 12202;
     */
    GROUPV2_INVENTORY_COMMITTED = 12202,
    /**
     * @generated from protobuf enum value: GROUPV2_INVENTORY_COMMITTED_VALUE = 12203;
     */
    GROUPV2_INVENTORY_COMMITTED_VALUE = 12203,
    /**
     * @generated from protobuf enum value: GROUPV2_INVENTORY_ON_ORDER = 12204;
     */
    GROUPV2_INVENTORY_ON_ORDER = 12204,
    /**
     * @generated from protobuf enum value: GROUPV2_INVENTORY_ON_ORDER_VALUE = 12205;
     */
    GROUPV2_INVENTORY_ON_ORDER_VALUE = 12205,
    /**
     * @generated from protobuf enum value: GROUPV2_INVENTORY_ANNUAL_TURNS = 12206;
     */
    GROUPV2_INVENTORY_ANNUAL_TURNS = 12206,
    /**
     * @generated from protobuf enum value: GROUPV2_INVENTORY_MIN = 12207;
     */
    GROUPV2_INVENTORY_MIN = 12207,
    /**
     * @generated from protobuf enum value: GROUPV2_INVENTORY_MAX = 12208;
     */
    GROUPV2_INVENTORY_MAX = 12208,
    /**
     * @generated from protobuf enum value: GROUPV2_INVENTORY_ANNUAL_UNITS_SOLD = 12215;
     */
    GROUPV2_INVENTORY_ANNUAL_UNITS_SOLD = 12215,
    /**
     * @generated from protobuf enum value: GROUPV2_INVENTORY_STOCK = 12216;
     */
    GROUPV2_INVENTORY_STOCK = 12216,
    /**
     * @generated from protobuf enum value: GROUPV2_INVENTORY_STOCK_VALUE = 12217;
     */
    GROUPV2_INVENTORY_STOCK_VALUE = 12217,
    /**
     * @generated from protobuf enum value: GROUPV2_INVENTORY_AVERAGE_COST = 12218;
     */
    GROUPV2_INVENTORY_AVERAGE_COST = 12218,
    /**
     * @generated from protobuf enum value: GROUPV2_INVENTORY_LEDGER_VALUATION = 12219;
     */
    GROUPV2_INVENTORY_LEDGER_VALUATION = 12219,
    /**
     * @generated from protobuf enum value: GROUPV2_INVENTORY_TRANSACTION__EDIT_TAG = 12220;
     */
    GROUPV2_INVENTORY_TRANSACTION__EDIT_TAG = 12220,
    /**
     * metrics: order product
     *
     * @generated from protobuf enum value: GROUPV2_ORDER__PRODUCT_QUANTITY_ORDERED = 12300;
     */
    GROUPV2_ORDER__PRODUCT_QUANTITY_ORDERED = 12300,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER__PRODUCT_QUANTITY_RECEIVED = 12301;
     */
    GROUPV2_ORDER__PRODUCT_QUANTITY_RECEIVED = 12301,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER__PRODUCT_QUANTITY_DISCREPANCY = 12302;
     */
    GROUPV2_ORDER__PRODUCT_QUANTITY_DISCREPANCY = 12302,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER__PRODUCT_COST = 12303;
     */
    GROUPV2_ORDER__PRODUCT_COST = 12303,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER_PRODUCT_TOTAL_COST = 12304;
     */
    GROUPV2_ORDER_PRODUCT_TOTAL_COST = 12304,
    /**
     * metrics: transaction taxes
     *
     * @generated from protobuf enum value: GROUPV2_TAXABLE_SURCHARGE = 12500;
     */
    GROUPV2_TAXABLE_SURCHARGE = 12500,
    /**
     * @generated from protobuf enum value: GROUPV2_NON_TAXABLE_SURCHARGE = 12501;
     */
    GROUPV2_NON_TAXABLE_SURCHARGE = 12501,
    /**
     * @generated from protobuf enum value: GROUPV2_SURCHARGE_TAX = 12502;
     */
    GROUPV2_SURCHARGE_TAX = 12502,
    /**
     * @generated from protobuf enum value: GROUPV2_TAXABLE_SUBTOTAL = 12503;
     */
    GROUPV2_TAXABLE_SUBTOTAL = 12503,
    /**
     * @generated from protobuf enum value: GROUPV2_NON_TAXABLE_SUBTOTAL = 12504;
     */
    GROUPV2_NON_TAXABLE_SUBTOTAL = 12504,
    /**
     * @generated from protobuf enum value: GROUPV2_TAXABLE_FEES = 12505;
     */
    GROUPV2_TAXABLE_FEES = 12505,
    /**
     * @generated from protobuf enum value: GROUPV2_NON_TAXABLE_FEES = 12506;
     */
    GROUPV2_NON_TAXABLE_FEES = 12506,
    /**
     * @generated from protobuf enum value: GROUPV2_BASE_SALES_TAX = 12507;
     */
    GROUPV2_BASE_SALES_TAX = 12507,
    /**
     * base sales tax + surcharge tax
     *
     * @generated from protobuf enum value: GROUPV2_TAX_OWED = 12508;
     */
    GROUPV2_TAX_OWED = 12508,
    /**
     * metrics: shipped products
     *
     * @generated from protobuf enum value: GROUPV2_SHIPMENT_PRODUCTS_ADDITIONAL_FEE_AMOUNT = 12600;
     */
    GROUPV2_SHIPMENT_PRODUCTS_ADDITIONAL_FEE_AMOUNT = 12600,
    /**
     * @generated from protobuf enum value: GROUPV2_SHIPMENT_PRODUCTS_COST = 12601;
     */
    GROUPV2_SHIPMENT_PRODUCTS_COST = 12601,
    /**
     * @generated from protobuf enum value: GROUPV2_SHIPMENT_PRODUCTS_QUANTITY_RECEIVED = 12602;
     */
    GROUPV2_SHIPMENT_PRODUCTS_QUANTITY_RECEIVED = 12602,
    /**
     * @generated from protobuf enum value: GROUPV2_SHIPMENT_PRODUCTS_QUANTITY_SHIPPED = 12603;
     */
    GROUPV2_SHIPMENT_PRODUCTS_QUANTITY_SHIPPED = 12603,
    /**
     * @generated from protobuf enum value: GROUPV2_SHIPMENT_PRODUCTS_TOTAL_COST = 12604;
     */
    GROUPV2_SHIPMENT_PRODUCTS_TOTAL_COST = 12604,
    /**
     * metrics: order shipment
     *
     * @generated from protobuf enum value: GROUPV2_ORDER_SHIPMENT_NET_COST_ADJUSTMENTS = 12700;
     */
    GROUPV2_ORDER_SHIPMENT_NET_COST_ADJUSTMENTS = 12700,
    /**
     * @generated from protobuf enum value: GROUPV2_ORDER_SHIPMENT_TOTAL_RECEIVED = 12701;
     */
    GROUPV2_ORDER_SHIPMENT_TOTAL_RECEIVED = 12701,
    /**
     * product cost subtotal (excl. fees and adjustments)
     *
     * @generated from protobuf enum value: GROUPV2_ORDER_SHIPMENT_SUBTOTAL = 12702;
     */
    GROUPV2_ORDER_SHIPMENT_SUBTOTAL = 12702,
    /**
     * sum of all per-product additional fees
     *
     * @generated from protobuf enum value: GROUPV2_ORDER_SHIPMENT_FEE_TOTAL = 12703;
     */
    GROUPV2_ORDER_SHIPMENT_FEE_TOTAL = 12703,
    /**
     * subtotal + fees + cost adjustments
     *
     * @generated from protobuf enum value: GROUPV2_ORDER_SHIPMENT_TOTAL = 12704;
     */
    GROUPV2_ORDER_SHIPMENT_TOTAL = 12704,
    /**
     * metrics: aging
     *
     * @generated from protobuf enum value: GROUPV2_AGING_BALANCE_1_30_DAYS = 12800;
     */
    GROUPV2_AGING_BALANCE_1_30_DAYS = 12800,
    /**
     * @generated from protobuf enum value: GROUPV2_AGING_BALANCE_31_60_DAYS = 12801;
     */
    GROUPV2_AGING_BALANCE_31_60_DAYS = 12801,
    /**
     * @generated from protobuf enum value: GROUPV2_AGING_BALANCE_61_PLUS_DAYS = 12802;
     */
    GROUPV2_AGING_BALANCE_61_PLUS_DAYS = 12802,
    /**
     * @generated from protobuf enum value: GROUPV2_AGING_CREDITS = 12803;
     */
    GROUPV2_AGING_CREDITS = 12803,
    /**
     * @generated from protobuf enum value: GROUPV2_AGING_FINANCING_CHARGES = 12804;
     */
    GROUPV2_AGING_FINANCING_CHARGES = 12804,
    /**
     * not yet late balance
     *
     * @generated from protobuf enum value: GROUPV2_AGING_BALANCE_CURRENT = 12806;
     */
    GROUPV2_AGING_BALANCE_CURRENT = 12806,
    /**
     * @generated from protobuf enum value: GROUPV2_AGING_BALANCE_61_TO_90_DAYS = 12807;
     */
    GROUPV2_AGING_BALANCE_61_TO_90_DAYS = 12807,
    /**
     * @generated from protobuf enum value: GROUPV2_AGING_BALANCE_91_PLUS_DAYS = 12808;
     */
    GROUPV2_AGING_BALANCE_91_PLUS_DAYS = 12808,
    /**
     * @generated from protobuf enum value: GROUPV2_AGING_BALANCE_LATE = 12809;
     */
    GROUPV2_AGING_BALANCE_LATE = 12809,
    /**
     * metrics: aging
     *
     * @generated from protobuf enum value: GROUPV2_AGING_DETAIL_DAYS_OVERDUE = 12900;
     */
    GROUPV2_AGING_DETAIL_DAYS_OVERDUE = 12900,
    /**
     * @generated from protobuf enum value: GROUPV2_AGING_DETAIL_BALANCE = 12901;
     */
    GROUPV2_AGING_DETAIL_BALANCE = 12901,
    /**
     * metrics: product cost
     *
     * @generated from protobuf enum value: GROUPV2_PRODUCT_COST_AMOUNT = 13000;
     */
    GROUPV2_PRODUCT_COST_AMOUNT = 13000,
    /**
     * metrics: payment adjustments
     *
     * adjusted payment amount
     *
     * @generated from protobuf enum value: GROUPV2_PAYMENT_ADJUSTMENT__PAYMENT_AMOUNT = 13100;
     */
    GROUPV2_PAYMENT_ADJUSTMENT__PAYMENT_AMOUNT = 13100,
    /**
     * original invoice amount
     *
     * @generated from protobuf enum value: GROUPV2_PAYMENT_ADJUSTMENT__ORIGINAL_AMOUNT = 13101;
     */
    GROUPV2_PAYMENT_ADJUSTMENT__ORIGINAL_AMOUNT = 13101,
    /**
     * metrics: transaction write-offs
     *
     * @generated from protobuf enum value: GROUPV2_WRITE_OFF_INVOICE_ALLOCATION = 13200;
     */
    GROUPV2_WRITE_OFF_INVOICE_ALLOCATION = 13200,
    /**
     * @generated from protobuf enum value: GROUPV2_WRITE_OFF_FC_ALLOCATION = 13201;
     */
    GROUPV2_WRITE_OFF_FC_ALLOCATION = 13201,
    /**
     * metrics: product pricing tiers
     *
     * @generated from protobuf enum value: GROUPV2_PRODUCT_PRICING_TIER_DOLLAR_PRICE = 13300;
     */
    GROUPV2_PRODUCT_PRICING_TIER_DOLLAR_PRICE = 13300,
    /**
     * @generated from protobuf enum value: GROUPV2_PRODUCT_PRICING_TIER_MARGIN_PERCENT = 13301;
     */
    GROUPV2_PRODUCT_PRICING_TIER_MARGIN_PERCENT = 13301,
    /**
     * @generated from protobuf enum value: GROUPV2_PRODUCT_PRICING_TIER_DISCOUNT_PERCENT = 13302;
     */
    GROUPV2_PRODUCT_PRICING_TIER_DISCOUNT_PERCENT = 13302,
    /**
     * metrics: spiffs
     *
     * @generated from protobuf enum value: GROUPV2_SPIFF__TOTAL_SPIFF_AMOUNT = 13400;
     */
    GROUPV2_SPIFF__TOTAL_SPIFF_AMOUNT = 13400,
    /**
     * @generated from protobuf enum value: GROUPV2_SPIFF_UNITS_SOLD = 13401;
     */
    GROUPV2_SPIFF_UNITS_SOLD = 13401,
    /**
     * @generated from protobuf enum value: GROUPV2_SPIFF_UNITS_RETURNED = 13402;
     */
    GROUPV2_SPIFF_UNITS_RETURNED = 13402,
    /**
     * @generated from protobuf enum value: GROUPV2_SPIFF_UNITS_NET = 13403;
     */
    GROUPV2_SPIFF_UNITS_NET = 13403,
    /**
     * metrics: gift card balances
     *
     * @generated from protobuf enum value: GROUPV2_GIFT_CARD_ORIGINAL_AMOUNT = 13500;
     */
    GROUPV2_GIFT_CARD_ORIGINAL_AMOUNT = 13500,
    /**
     * @generated from protobuf enum value: GROUPV2_GIFT_CARD_HISTORICAL_BALANCE = 13501;
     */
    GROUPV2_GIFT_CARD_HISTORICAL_BALANCE = 13501,
    /**
     * @generated from protobuf enum value: GROUPV2_GIFT_CARD_CURRENT_BALANCE = 13502;
     */
    GROUPV2_GIFT_CARD_CURRENT_BALANCE = 13502,
    /**
     * metrics: single entries
     *
     * @generated from protobuf enum value: GROUPV2_SINGLE_ENTRY__DEBIT = 13600;
     */
    GROUPV2_SINGLE_ENTRY__DEBIT = 13600,
    /**
     * @generated from protobuf enum value: GROUPV2_SINGLE_ENTRY__CREDIT = 13601;
     */
    GROUPV2_SINGLE_ENTRY__CREDIT = 13601,
    /**
     * @generated from protobuf enum value: GROUPV2_SINGLE_ENTRY__DELTA = 13602;
     */
    GROUPV2_SINGLE_ENTRY__DELTA = 13602,
    /**
     * @generated from protobuf enum value: GROUPV2_SINGLE_ENTRY__SIGNED_DELTA = 13603;
     */
    GROUPV2_SINGLE_ENTRY__SIGNED_DELTA = 13603,
    /**
     * @generated from protobuf enum value: GROUPV2_SINGLE_ENTRY__GROSS_PROFIT = 13604;
     */
    GROUPV2_SINGLE_ENTRY__GROSS_PROFIT = 13604,
    /**
     * @generated from protobuf enum value: GROUPV2_SINGLE_ENTRY__NET_PROFIT = 13605;
     */
    GROUPV2_SINGLE_ENTRY__NET_PROFIT = 13605,
    /**
     * @generated from protobuf enum value: GROUPV2_SINGLE_ENTRY__CONTROL_DELTA = 13606;
     */
    GROUPV2_SINGLE_ENTRY__CONTROL_DELTA = 13606,
    /**
     * @generated from protobuf enum value: GROUPV2_SINGLE_ENTRY__ADDITIONAL_FEE = 13607;
     */
    GROUPV2_SINGLE_ENTRY__ADDITIONAL_FEE = 13607,
    /**
     * metrics: deliveries
     *
     * @generated from protobuf enum value: GROUPV2_DELIVERY_STOP_COUNT = 14200;
     */
    GROUPV2_DELIVERY_STOP_COUNT = 14200,
    /**
     * @generated from protobuf enum value: GROUPV2_DELIVERY_SALE_COUNT = 14201;
     */
    GROUPV2_DELIVERY_SALE_COUNT = 14201
}
/**
 * Aggregation specifies custom aggregation, most of which apply to metric columns (the one
 * exception being COUNT_DISTINCT).
 *
 * @generated from protobuf enum rd.analyticsv2.reportbuilder.Aggregation
 */
export enum Aggregation {
    /**
     * Default aggregation: SUM for metric and DISTINCT for labels. Some group
     * types have special-case aggregations (e.g. margin).
     *
     * @generated from protobuf enum value: AGGREGATION_DEFAULT = 0;
     */
    DEFAULT = 0,
    /**
     * @generated from protobuf enum value: AGGREGATION_SUM = 1;
     */
    SUM = 1,
    /**
     * @generated from protobuf enum value: AGGREGATION_AVERAGE = 2;
     */
    AVERAGE = 2,
    /**
     * @generated from protobuf enum value: AGGREGATION_MIN = 3;
     */
    MIN = 3,
    /**
     * @generated from protobuf enum value: AGGREGATION_MAX = 4;
     */
    MAX = 4,
    /**
     * Unlike the other aggregations, this applies only to label groups. It
     * returns a string representing the number of unique values OR the original
     * string value if there was only one.
     *
     * @generated from protobuf enum value: AGGREGATION_DISTINCT = 5;
     */
    DISTINCT = 5,
    /**
     * COUNT is similar to DISTINCT but always returns an integer value (even
     * when there is only one unique value).
     *
     * @generated from protobuf enum value: AGGREGATION_COUNT = 6;
     */
    COUNT = 6,
    /**
     * Use for earliest date/time values within groups (lexicographically smallest).
     *
     * @generated from protobuf enum value: AGGREGATION_EARLIEST = 7;
     */
    EARLIEST = 7,
    /**
     * Use for latest date/time values within groups (lexicographically largest).
     *
     * @generated from protobuf enum value: AGGREGATION_LATEST = 8;
     */
    LATEST = 8
}
// @generated message type with reflection information, may provide speed optimized methods
class Report$Type extends MessageType<Report> {
    constructor() {
        super("rd.analyticsv2.reportbuilder.Report", [
            { no: 1, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "subtitle", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "series", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Report_Series },
            { no: 4, name: "table", kind: "message", T: () => Report_Table },
            { no: 5, name: "report_builder_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Report>): Report {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.title = "";
        message.subtitle = "";
        message.series = [];
        message.reportBuilderUrl = "";
        if (value !== undefined)
            reflectionMergePartial<Report>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Report): Report {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string title */ 1:
                    message.title = reader.string();
                    break;
                case /* string subtitle */ 2:
                    message.subtitle = reader.string();
                    break;
                case /* repeated rd.analyticsv2.reportbuilder.Report.Series series */ 3:
                    message.series.push(Report_Series.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.analyticsv2.reportbuilder.Report.Table table */ 4:
                    message.table = Report_Table.internalBinaryRead(reader, reader.uint32(), options, message.table);
                    break;
                case /* string report_builder_url */ 5:
                    message.reportBuilderUrl = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Report, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string title = 1; */
        if (message.title !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.title);
        /* string subtitle = 2; */
        if (message.subtitle !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.subtitle);
        /* repeated rd.analyticsv2.reportbuilder.Report.Series series = 3; */
        for (let i = 0; i < message.series.length; i++)
            Report_Series.internalBinaryWrite(message.series[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.analyticsv2.reportbuilder.Report.Table table = 4; */
        if (message.table)
            Report_Table.internalBinaryWrite(message.table, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string report_builder_url = 5; */
        if (message.reportBuilderUrl !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.reportBuilderUrl);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.analyticsv2.reportbuilder.Report
 */
export const Report = new Report$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Report_Series$Type extends MessageType<Report_Series> {
    constructor() {
        super("rd.analyticsv2.reportbuilder.Report.Series", [
            { no: 1, name: "type", kind: "enum", T: () => ["rd.analyticsv2.reportbuilder.Report.Series.Type", Report_Series_Type, "TYPE_"] },
            { no: 2, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "points", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Report_Series_Point },
            { no: 4, name: "unit", kind: "enum", T: () => ["rd.analyticsv2.reportbuilder.Report.Series.Unit", Report_Series_Unit, "UNIT_"] },
            { no: 5, name: "subgroups", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Report_Series>): Report_Series {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = 0;
        message.label = "";
        message.points = [];
        message.unit = 0;
        message.subgroups = [];
        if (value !== undefined)
            reflectionMergePartial<Report_Series>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Report_Series): Report_Series {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analyticsv2.reportbuilder.Report.Series.Type type */ 1:
                    message.type = reader.int32();
                    break;
                case /* string label */ 2:
                    message.label = reader.string();
                    break;
                case /* repeated rd.analyticsv2.reportbuilder.Report.Series.Point points */ 3:
                    message.points.push(Report_Series_Point.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.analyticsv2.reportbuilder.Report.Series.Unit unit */ 4:
                    message.unit = reader.int32();
                    break;
                case /* repeated string subgroups */ 5:
                    message.subgroups.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Report_Series, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analyticsv2.reportbuilder.Report.Series.Type type = 1; */
        if (message.type !== 0)
            writer.tag(1, WireType.Varint).int32(message.type);
        /* string label = 2; */
        if (message.label !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.label);
        /* repeated rd.analyticsv2.reportbuilder.Report.Series.Point points = 3; */
        for (let i = 0; i < message.points.length; i++)
            Report_Series_Point.internalBinaryWrite(message.points[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.analyticsv2.reportbuilder.Report.Series.Unit unit = 4; */
        if (message.unit !== 0)
            writer.tag(4, WireType.Varint).int32(message.unit);
        /* repeated string subgroups = 5; */
        for (let i = 0; i < message.subgroups.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.subgroups[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.analyticsv2.reportbuilder.Report.Series
 */
export const Report_Series = new Report_Series$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Report_Series_Point$Type extends MessageType<Report_Series_Point> {
    constructor() {
        super("rd.analyticsv2.reportbuilder.Report.Series.Point", [
            { no: 1, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "value", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 3, name: "groups", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Report_Series_Point>): Report_Series_Point {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.label = "";
        message.value = 0;
        message.groups = [];
        if (value !== undefined)
            reflectionMergePartial<Report_Series_Point>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Report_Series_Point): Report_Series_Point {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string label */ 1:
                    message.label = reader.string();
                    break;
                case /* float value */ 2:
                    message.value = reader.float();
                    break;
                case /* repeated string groups */ 3:
                    message.groups.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Report_Series_Point, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string label = 1; */
        if (message.label !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.label);
        /* float value = 2; */
        if (message.value !== 0)
            writer.tag(2, WireType.Bit32).float(message.value);
        /* repeated string groups = 3; */
        for (let i = 0; i < message.groups.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.groups[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.analyticsv2.reportbuilder.Report.Series.Point
 */
export const Report_Series_Point = new Report_Series_Point$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Report_Table$Type extends MessageType<Report_Table> {
    constructor() {
        super("rd.analyticsv2.reportbuilder.Report.Table", [
            { no: 1, name: "headers", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "rows", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Report_Table_Row },
            { no: 3, name: "summary", kind: "message", T: () => Report_Table_Row },
            { no: 4, name: "headers_v2", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Report_Table_Header },
            { no: 5, name: "total_rows", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<Report_Table>): Report_Table {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.headers = [];
        message.rows = [];
        message.headersV2 = [];
        message.totalRows = 0;
        if (value !== undefined)
            reflectionMergePartial<Report_Table>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Report_Table): Report_Table {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string headers */ 1:
                    message.headers.push(reader.string());
                    break;
                case /* repeated rd.analyticsv2.reportbuilder.Report.Table.Row rows */ 2:
                    message.rows.push(Report_Table_Row.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.analyticsv2.reportbuilder.Report.Table.Row summary */ 3:
                    message.summary = Report_Table_Row.internalBinaryRead(reader, reader.uint32(), options, message.summary);
                    break;
                case /* repeated rd.analyticsv2.reportbuilder.Report.Table.Header headers_v2 */ 4:
                    message.headersV2.push(Report_Table_Header.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_rows */ 5:
                    message.totalRows = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Report_Table, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string headers = 1; */
        for (let i = 0; i < message.headers.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.headers[i]);
        /* repeated rd.analyticsv2.reportbuilder.Report.Table.Row rows = 2; */
        for (let i = 0; i < message.rows.length; i++)
            Report_Table_Row.internalBinaryWrite(message.rows[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.analyticsv2.reportbuilder.Report.Table.Row summary = 3; */
        if (message.summary)
            Report_Table_Row.internalBinaryWrite(message.summary, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.analyticsv2.reportbuilder.Report.Table.Header headers_v2 = 4; */
        for (let i = 0; i < message.headersV2.length; i++)
            Report_Table_Header.internalBinaryWrite(message.headersV2[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_rows = 5; */
        if (message.totalRows !== 0)
            writer.tag(5, WireType.Varint).int32(message.totalRows);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.analyticsv2.reportbuilder.Report.Table
 */
export const Report_Table = new Report_Table$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Report_Table_Cell$Type extends MessageType<Report_Table_Cell> {
    constructor() {
        super("rd.analyticsv2.reportbuilder.Report.Table.Cell", [
            { no: 1, name: "type", kind: "enum", T: () => ["rd.analyticsv2.reportbuilder.Report.Table.Cell.Type", Report_Table_Cell_Type, "TYPE_"] },
            { no: 2, name: "string_val", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "decimal_val", kind: "message", T: () => Decimal },
            { no: 4, name: "money_val", kind: "message", T: () => Money },
            { no: 5, name: "fractional_money_val", kind: "message", T: () => FractionalMoney },
            { no: 6, name: "int_val", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 7, name: "metadata", kind: "message", T: () => Report_Table_Cell_Metadata }
        ]);
    }
    create(value?: PartialMessage<Report_Table_Cell>): Report_Table_Cell {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.type = 0;
        message.stringVal = "";
        message.intVal = 0n;
        if (value !== undefined)
            reflectionMergePartial<Report_Table_Cell>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Report_Table_Cell): Report_Table_Cell {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analyticsv2.reportbuilder.Report.Table.Cell.Type type */ 1:
                    message.type = reader.int32();
                    break;
                case /* string string_val */ 2:
                    message.stringVal = reader.string();
                    break;
                case /* rd.proto.decimal.Decimal decimal_val */ 3:
                    message.decimalVal = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.decimalVal);
                    break;
                case /* rd.proto.money.Money money_val */ 4:
                    message.moneyVal = Money.internalBinaryRead(reader, reader.uint32(), options, message.moneyVal);
                    break;
                case /* rd.proto.money.FractionalMoney fractional_money_val */ 5:
                    message.fractionalMoneyVal = FractionalMoney.internalBinaryRead(reader, reader.uint32(), options, message.fractionalMoneyVal);
                    break;
                case /* int64 int_val */ 6:
                    message.intVal = reader.int64().toBigInt();
                    break;
                case /* rd.analyticsv2.reportbuilder.Report.Table.Cell.Metadata metadata */ 7:
                    message.metadata = Report_Table_Cell_Metadata.internalBinaryRead(reader, reader.uint32(), options, message.metadata);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Report_Table_Cell, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analyticsv2.reportbuilder.Report.Table.Cell.Type type = 1; */
        if (message.type !== 0)
            writer.tag(1, WireType.Varint).int32(message.type);
        /* string string_val = 2; */
        if (message.stringVal !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.stringVal);
        /* rd.proto.decimal.Decimal decimal_val = 3; */
        if (message.decimalVal)
            Decimal.internalBinaryWrite(message.decimalVal, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money money_val = 4; */
        if (message.moneyVal)
            Money.internalBinaryWrite(message.moneyVal, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.FractionalMoney fractional_money_val = 5; */
        if (message.fractionalMoneyVal)
            FractionalMoney.internalBinaryWrite(message.fractionalMoneyVal, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* int64 int_val = 6; */
        if (message.intVal !== 0n)
            writer.tag(6, WireType.Varint).int64(message.intVal);
        /* rd.analyticsv2.reportbuilder.Report.Table.Cell.Metadata metadata = 7; */
        if (message.metadata)
            Report_Table_Cell_Metadata.internalBinaryWrite(message.metadata, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.analyticsv2.reportbuilder.Report.Table.Cell
 */
export const Report_Table_Cell = new Report_Table_Cell$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Report_Table_Cell_Metadata$Type extends MessageType<Report_Table_Cell_Metadata> {
    constructor() {
        super("rd.analyticsv2.reportbuilder.Report.Table.Cell.Metadata", [
            { no: 1, name: "filters", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Filter }
        ]);
    }
    create(value?: PartialMessage<Report_Table_Cell_Metadata>): Report_Table_Cell_Metadata {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.filters = [];
        if (value !== undefined)
            reflectionMergePartial<Report_Table_Cell_Metadata>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Report_Table_Cell_Metadata): Report_Table_Cell_Metadata {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.analyticsv2.reportbuilder.Filter filters */ 1:
                    message.filters.push(Filter.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Report_Table_Cell_Metadata, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.analyticsv2.reportbuilder.Filter filters = 1; */
        for (let i = 0; i < message.filters.length; i++)
            Filter.internalBinaryWrite(message.filters[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.analyticsv2.reportbuilder.Report.Table.Cell.Metadata
 */
export const Report_Table_Cell_Metadata = new Report_Table_Cell_Metadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Report_Table_Row$Type extends MessageType<Report_Table_Row> {
    constructor() {
        super("rd.analyticsv2.reportbuilder.Report.Table.Row", [
            { no: 1, name: "cells", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "cells_v2", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Report_Table_Cell }
        ]);
    }
    create(value?: PartialMessage<Report_Table_Row>): Report_Table_Row {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.cells = [];
        message.cellsV2 = [];
        if (value !== undefined)
            reflectionMergePartial<Report_Table_Row>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Report_Table_Row): Report_Table_Row {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string cells */ 1:
                    message.cells.push(reader.string());
                    break;
                case /* repeated rd.analyticsv2.reportbuilder.Report.Table.Cell cells_v2 */ 2:
                    message.cellsV2.push(Report_Table_Cell.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Report_Table_Row, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string cells = 1; */
        for (let i = 0; i < message.cells.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.cells[i]);
        /* repeated rd.analyticsv2.reportbuilder.Report.Table.Cell cells_v2 = 2; */
        for (let i = 0; i < message.cellsV2.length; i++)
            Report_Table_Cell.internalBinaryWrite(message.cellsV2[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.analyticsv2.reportbuilder.Report.Table.Row
 */
export const Report_Table_Row = new Report_Table_Row$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Report_Table_Header$Type extends MessageType<Report_Table_Header> {
    constructor() {
        super("rd.analyticsv2.reportbuilder.Report.Table.Header", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "subgroup_values", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "original_column", kind: "message", T: () => ReportParamsV2_Column },
            { no: 4, name: "allowed_aggregations", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.analyticsv2.reportbuilder.Aggregation", Aggregation, "AGGREGATION_"] },
            { no: 5, name: "cell_type", kind: "enum", T: () => ["rd.analyticsv2.reportbuilder.Report.Table.Cell.Type", Report_Table_Cell_Type, "TYPE_"] },
            { no: 6, name: "comparison_info", kind: "message", T: () => Report_Table_Header_ComparisonColumnInfo },
            { no: 8, name: "comparison_name_suffix", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "default_aggregation", kind: "enum", T: () => ["rd.analyticsv2.reportbuilder.Aggregation", Aggregation, "AGGREGATION_"] }
        ]);
    }
    create(value?: PartialMessage<Report_Table_Header>): Report_Table_Header {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.subgroupValues = [];
        message.allowedAggregations = [];
        message.cellType = 0;
        message.comparisonNameSuffix = "";
        message.description = "";
        message.defaultAggregation = 0;
        if (value !== undefined)
            reflectionMergePartial<Report_Table_Header>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Report_Table_Header): Report_Table_Header {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* repeated string subgroup_values */ 2:
                    message.subgroupValues.push(reader.string());
                    break;
                case /* rd.analyticsv2.reportbuilder.ReportParamsV2.Column original_column */ 3:
                    message.originalColumn = ReportParamsV2_Column.internalBinaryRead(reader, reader.uint32(), options, message.originalColumn);
                    break;
                case /* repeated rd.analyticsv2.reportbuilder.Aggregation allowed_aggregations */ 4:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.allowedAggregations.push(reader.int32());
                    else
                        message.allowedAggregations.push(reader.int32());
                    break;
                case /* rd.analyticsv2.reportbuilder.Report.Table.Cell.Type cell_type */ 5:
                    message.cellType = reader.int32();
                    break;
                case /* rd.analyticsv2.reportbuilder.Report.Table.Header.ComparisonColumnInfo comparison_info */ 6:
                    message.comparisonInfo = Report_Table_Header_ComparisonColumnInfo.internalBinaryRead(reader, reader.uint32(), options, message.comparisonInfo);
                    break;
                case /* string comparison_name_suffix */ 8:
                    message.comparisonNameSuffix = reader.string();
                    break;
                case /* string description */ 9:
                    message.description = reader.string();
                    break;
                case /* rd.analyticsv2.reportbuilder.Aggregation default_aggregation */ 10:
                    message.defaultAggregation = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Report_Table_Header, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* repeated string subgroup_values = 2; */
        for (let i = 0; i < message.subgroupValues.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.subgroupValues[i]);
        /* rd.analyticsv2.reportbuilder.ReportParamsV2.Column original_column = 3; */
        if (message.originalColumn)
            ReportParamsV2_Column.internalBinaryWrite(message.originalColumn, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.analyticsv2.reportbuilder.Aggregation allowed_aggregations = 4; */
        if (message.allowedAggregations.length) {
            writer.tag(4, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.allowedAggregations.length; i++)
                writer.int32(message.allowedAggregations[i]);
            writer.join();
        }
        /* rd.analyticsv2.reportbuilder.Report.Table.Cell.Type cell_type = 5; */
        if (message.cellType !== 0)
            writer.tag(5, WireType.Varint).int32(message.cellType);
        /* rd.analyticsv2.reportbuilder.Report.Table.Header.ComparisonColumnInfo comparison_info = 6; */
        if (message.comparisonInfo)
            Report_Table_Header_ComparisonColumnInfo.internalBinaryWrite(message.comparisonInfo, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* string comparison_name_suffix = 8; */
        if (message.comparisonNameSuffix !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.comparisonNameSuffix);
        /* string description = 9; */
        if (message.description !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.description);
        /* rd.analyticsv2.reportbuilder.Aggregation default_aggregation = 10; */
        if (message.defaultAggregation !== 0)
            writer.tag(10, WireType.Varint).int32(message.defaultAggregation);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.analyticsv2.reportbuilder.Report.Table.Header
 */
export const Report_Table_Header = new Report_Table_Header$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Report_Table_Header_ComparisonColumnInfo$Type extends MessageType<Report_Table_Header_ComparisonColumnInfo> {
    constructor() {
        super("rd.analyticsv2.reportbuilder.Report.Table.Header.ComparisonColumnInfo", [
            { no: 1, name: "base_column_offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "compare_column_offset", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "dc_key", kind: "message", T: () => ReportParamsV2_DateCompareColumnKey }
        ]);
    }
    create(value?: PartialMessage<Report_Table_Header_ComparisonColumnInfo>): Report_Table_Header_ComparisonColumnInfo {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.baseColumnOffset = 0;
        message.compareColumnOffset = 0;
        if (value !== undefined)
            reflectionMergePartial<Report_Table_Header_ComparisonColumnInfo>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Report_Table_Header_ComparisonColumnInfo): Report_Table_Header_ComparisonColumnInfo {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 base_column_offset */ 1:
                    message.baseColumnOffset = reader.int32();
                    break;
                case /* int32 compare_column_offset */ 2:
                    message.compareColumnOffset = reader.int32();
                    break;
                case /* rd.analyticsv2.reportbuilder.ReportParamsV2.DateCompareColumnKey dc_key */ 3:
                    message.dcKey = ReportParamsV2_DateCompareColumnKey.internalBinaryRead(reader, reader.uint32(), options, message.dcKey);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Report_Table_Header_ComparisonColumnInfo, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 base_column_offset = 1; */
        if (message.baseColumnOffset !== 0)
            writer.tag(1, WireType.Varint).int32(message.baseColumnOffset);
        /* int32 compare_column_offset = 2; */
        if (message.compareColumnOffset !== 0)
            writer.tag(2, WireType.Varint).int32(message.compareColumnOffset);
        /* rd.analyticsv2.reportbuilder.ReportParamsV2.DateCompareColumnKey dc_key = 3; */
        if (message.dcKey)
            ReportParamsV2_DateCompareColumnKey.internalBinaryWrite(message.dcKey, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.analyticsv2.reportbuilder.Report.Table.Header.ComparisonColumnInfo
 */
export const Report_Table_Header_ComparisonColumnInfo = new Report_Table_Header_ComparisonColumnInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Filter$Type extends MessageType<Filter> {
    constructor() {
        super("rd.analyticsv2.reportbuilder.Filter", [
            { no: 1, name: "attribute", kind: "enum", T: () => ["rd.analyticsv2.reportbuilder.Filter.Attribute", Filter_Attribute, "ATTRIBUTE_"] },
            { no: 2, name: "id", kind: "message", T: () => UUID },
            { no: 3, name: "enum_val", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "label", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "bool_val", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "string_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "date_range", kind: "message", T: () => TimestampRange }
        ]);
    }
    create(value?: PartialMessage<Filter>): Filter {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.attribute = 0;
        message.enumVal = 0;
        message.label = "";
        message.boolVal = false;
        message.stringId = "";
        if (value !== undefined)
            reflectionMergePartial<Filter>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Filter): Filter {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analyticsv2.reportbuilder.Filter.Attribute attribute */ 1:
                    message.attribute = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID id */ 2:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* int32 enum_val */ 3:
                    message.enumVal = reader.int32();
                    break;
                case /* string label */ 4:
                    message.label = reader.string();
                    break;
                case /* bool bool_val */ 5:
                    message.boolVal = reader.bool();
                    break;
                case /* string string_id */ 6:
                    message.stringId = reader.string();
                    break;
                case /* rd.proto.timestamprange.TimestampRange date_range */ 7:
                    message.dateRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.dateRange);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Filter, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analyticsv2.reportbuilder.Filter.Attribute attribute = 1; */
        if (message.attribute !== 0)
            writer.tag(1, WireType.Varint).int32(message.attribute);
        /* rd.proto.uuid.UUID id = 2; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* int32 enum_val = 3; */
        if (message.enumVal !== 0)
            writer.tag(3, WireType.Varint).int32(message.enumVal);
        /* string label = 4; */
        if (message.label !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.label);
        /* bool bool_val = 5; */
        if (message.boolVal !== false)
            writer.tag(5, WireType.Varint).bool(message.boolVal);
        /* string string_id = 6; */
        if (message.stringId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.stringId);
        /* rd.proto.timestamprange.TimestampRange date_range = 7; */
        if (message.dateRange)
            TimestampRange.internalBinaryWrite(message.dateRange, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.analyticsv2.reportbuilder.Filter
 */
export const Filter = new Filter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PredicateFilterKey$Type extends MessageType<PredicateFilterKey> {
    constructor() {
        super("rd.analyticsv2.reportbuilder.PredicateFilterKey", [
            { no: 1, name: "group", kind: "enum", T: () => ["rd.analyticsv2.reportbuilder.GroupV2", GroupV2] },
            { no: 2, name: "aggregation", kind: "enum", T: () => ["rd.analyticsv2.reportbuilder.Aggregation", Aggregation, "AGGREGATION_"] },
            { no: 3, name: "dc_key", kind: "message", T: () => ReportParamsV2_DateCompareColumnKey }
        ]);
    }
    create(value?: PartialMessage<PredicateFilterKey>): PredicateFilterKey {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.group = 0;
        message.aggregation = 0;
        if (value !== undefined)
            reflectionMergePartial<PredicateFilterKey>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PredicateFilterKey): PredicateFilterKey {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analyticsv2.reportbuilder.GroupV2 group */ 1:
                    message.group = reader.int32();
                    break;
                case /* rd.analyticsv2.reportbuilder.Aggregation aggregation */ 2:
                    message.aggregation = reader.int32();
                    break;
                case /* rd.analyticsv2.reportbuilder.ReportParamsV2.DateCompareColumnKey dc_key */ 3:
                    message.dcKey = ReportParamsV2_DateCompareColumnKey.internalBinaryRead(reader, reader.uint32(), options, message.dcKey);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PredicateFilterKey, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analyticsv2.reportbuilder.GroupV2 group = 1; */
        if (message.group !== 0)
            writer.tag(1, WireType.Varint).int32(message.group);
        /* rd.analyticsv2.reportbuilder.Aggregation aggregation = 2; */
        if (message.aggregation !== 0)
            writer.tag(2, WireType.Varint).int32(message.aggregation);
        /* rd.analyticsv2.reportbuilder.ReportParamsV2.DateCompareColumnKey dc_key = 3; */
        if (message.dcKey)
            ReportParamsV2_DateCompareColumnKey.internalBinaryWrite(message.dcKey, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.analyticsv2.reportbuilder.PredicateFilterKey
 */
export const PredicateFilterKey = new PredicateFilterKey$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PredicateFilter$Type extends MessageType<PredicateFilter> {
    constructor() {
        super("rd.analyticsv2.reportbuilder.PredicateFilter", [
            { no: 3, name: "op", kind: "enum", T: () => ["rd.analyticsv2.reportbuilder.PredicateFilter.Op", PredicateFilter_Op, "OP_"] },
            { no: 4, name: "value", kind: "message", T: () => Report_Table_Cell },
            { no: 5, name: "ColumnKey", kind: "message", jsonName: "ColumnKey", T: () => PredicateFilterKey },
            { no: 6, name: "values", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Report_Table_Cell }
        ]);
    }
    create(value?: PartialMessage<PredicateFilter>): PredicateFilter {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.op = 0;
        message.values = [];
        if (value !== undefined)
            reflectionMergePartial<PredicateFilter>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PredicateFilter): PredicateFilter {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analyticsv2.reportbuilder.PredicateFilter.Op op */ 3:
                    message.op = reader.int32();
                    break;
                case /* rd.analyticsv2.reportbuilder.Report.Table.Cell value */ 4:
                    message.value = Report_Table_Cell.internalBinaryRead(reader, reader.uint32(), options, message.value);
                    break;
                case /* rd.analyticsv2.reportbuilder.PredicateFilterKey ColumnKey */ 5:
                    message.columnKey = PredicateFilterKey.internalBinaryRead(reader, reader.uint32(), options, message.columnKey);
                    break;
                case /* repeated rd.analyticsv2.reportbuilder.Report.Table.Cell values */ 6:
                    message.values.push(Report_Table_Cell.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PredicateFilter, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analyticsv2.reportbuilder.PredicateFilter.Op op = 3; */
        if (message.op !== 0)
            writer.tag(3, WireType.Varint).int32(message.op);
        /* rd.analyticsv2.reportbuilder.Report.Table.Cell value = 4; */
        if (message.value)
            Report_Table_Cell.internalBinaryWrite(message.value, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.analyticsv2.reportbuilder.PredicateFilterKey ColumnKey = 5; */
        if (message.columnKey)
            PredicateFilterKey.internalBinaryWrite(message.columnKey, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.analyticsv2.reportbuilder.Report.Table.Cell values = 6; */
        for (let i = 0; i < message.values.length; i++)
            Report_Table_Cell.internalBinaryWrite(message.values[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.analyticsv2.reportbuilder.PredicateFilter
 */
export const PredicateFilter = new PredicateFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReportParams$Type extends MessageType<ReportParams> {
    constructor() {
        super("rd.analyticsv2.reportbuilder.ReportParams", [
            { no: 1, name: "data_source", kind: "enum", T: () => ["rd.analyticsv2.reportbuilder.DataSource", DataSource, "DATA_SOURCE_"] },
            { no: 2, name: "data_source_range", kind: "message", T: () => TimestampRange },
            { no: 3, name: "groups", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.analyticsv2.reportbuilder.Group", Group, "GROUP_"] },
            { no: 4, name: "subgroups", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.analyticsv2.reportbuilder.Group", Group, "GROUP_"] },
            { no: 5, name: "compare_unit", kind: "enum", T: () => ["rd.analyticsv2.reportbuilder.ReportParams.CompareUnit", ReportParams_CompareUnit, "COMPARE_UNIT_"] },
            { no: 6, name: "compare_amount", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "sort_column_index", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "sort_order", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "filters", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ReportParams_Filter },
            { no: 10, name: "gen_xy_table", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ReportParams>): ReportParams {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.dataSource = 0;
        message.groups = [];
        message.subgroups = [];
        message.compareUnit = 0;
        message.compareAmount = 0;
        message.sortColumnIndex = 0;
        message.sortOrder = 0;
        message.filters = [];
        message.genXyTable = false;
        if (value !== undefined)
            reflectionMergePartial<ReportParams>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReportParams): ReportParams {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analyticsv2.reportbuilder.DataSource data_source */ 1:
                    message.dataSource = reader.int32();
                    break;
                case /* rd.proto.timestamprange.TimestampRange data_source_range */ 2:
                    message.dataSourceRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.dataSourceRange);
                    break;
                case /* repeated rd.analyticsv2.reportbuilder.Group groups */ 3:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.groups.push(reader.int32());
                    else
                        message.groups.push(reader.int32());
                    break;
                case /* repeated rd.analyticsv2.reportbuilder.Group subgroups */ 4:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.subgroups.push(reader.int32());
                    else
                        message.subgroups.push(reader.int32());
                    break;
                case /* rd.analyticsv2.reportbuilder.ReportParams.CompareUnit compare_unit */ 5:
                    message.compareUnit = reader.int32();
                    break;
                case /* int32 compare_amount */ 6:
                    message.compareAmount = reader.int32();
                    break;
                case /* int32 sort_column_index */ 7:
                    message.sortColumnIndex = reader.int32();
                    break;
                case /* int32 sort_order */ 8:
                    message.sortOrder = reader.int32();
                    break;
                case /* repeated rd.analyticsv2.reportbuilder.ReportParams.Filter filters */ 9:
                    message.filters.push(ReportParams_Filter.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool gen_xy_table */ 10:
                    message.genXyTable = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReportParams, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analyticsv2.reportbuilder.DataSource data_source = 1; */
        if (message.dataSource !== 0)
            writer.tag(1, WireType.Varint).int32(message.dataSource);
        /* rd.proto.timestamprange.TimestampRange data_source_range = 2; */
        if (message.dataSourceRange)
            TimestampRange.internalBinaryWrite(message.dataSourceRange, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.analyticsv2.reportbuilder.Group groups = 3; */
        if (message.groups.length) {
            writer.tag(3, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.groups.length; i++)
                writer.int32(message.groups[i]);
            writer.join();
        }
        /* repeated rd.analyticsv2.reportbuilder.Group subgroups = 4; */
        if (message.subgroups.length) {
            writer.tag(4, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.subgroups.length; i++)
                writer.int32(message.subgroups[i]);
            writer.join();
        }
        /* rd.analyticsv2.reportbuilder.ReportParams.CompareUnit compare_unit = 5; */
        if (message.compareUnit !== 0)
            writer.tag(5, WireType.Varint).int32(message.compareUnit);
        /* int32 compare_amount = 6; */
        if (message.compareAmount !== 0)
            writer.tag(6, WireType.Varint).int32(message.compareAmount);
        /* int32 sort_column_index = 7; */
        if (message.sortColumnIndex !== 0)
            writer.tag(7, WireType.Varint).int32(message.sortColumnIndex);
        /* int32 sort_order = 8; */
        if (message.sortOrder !== 0)
            writer.tag(8, WireType.Varint).int32(message.sortOrder);
        /* repeated rd.analyticsv2.reportbuilder.ReportParams.Filter filters = 9; */
        for (let i = 0; i < message.filters.length; i++)
            ReportParams_Filter.internalBinaryWrite(message.filters[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* bool gen_xy_table = 10; */
        if (message.genXyTable !== false)
            writer.tag(10, WireType.Varint).bool(message.genXyTable);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.analyticsv2.reportbuilder.ReportParams
 */
export const ReportParams = new ReportParams$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReportParams_Filter$Type extends MessageType<ReportParams_Filter> {
    constructor() {
        super("rd.analyticsv2.reportbuilder.ReportParams.Filter", [
            { no: 1, name: "attribute", kind: "enum", T: () => ["rd.analyticsv2.reportbuilder.ReportParams.Filter.Attribute", ReportParams_Filter_Attribute, "ATTRIBUTE_"] },
            { no: 2, name: "id", kind: "message", T: () => UUID }
        ]);
    }
    create(value?: PartialMessage<ReportParams_Filter>): ReportParams_Filter {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.attribute = 0;
        if (value !== undefined)
            reflectionMergePartial<ReportParams_Filter>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReportParams_Filter): ReportParams_Filter {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analyticsv2.reportbuilder.ReportParams.Filter.Attribute attribute */ 1:
                    message.attribute = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID id */ 2:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReportParams_Filter, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analyticsv2.reportbuilder.ReportParams.Filter.Attribute attribute = 1; */
        if (message.attribute !== 0)
            writer.tag(1, WireType.Varint).int32(message.attribute);
        /* rd.proto.uuid.UUID id = 2; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.analyticsv2.reportbuilder.ReportParams.Filter
 */
export const ReportParams_Filter = new ReportParams_Filter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReportParamsV2$Type extends MessageType<ReportParamsV2> {
    constructor() {
        super("rd.analyticsv2.reportbuilder.ReportParamsV2", [
            { no: 1, name: "base_data", kind: "enum", T: () => ["rd.analyticsv2.reportbuilder.BaseData", BaseData, "BASE_DATA_"] },
            { no: 2, name: "data_source_range", kind: "message", T: () => TimestampRange },
            { no: 3, name: "columns", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ReportParamsV2_Column },
            { no: 6, name: "sort_column_index", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "sort_order", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "filters", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Filter },
            { no: 9, name: "unaggregated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "search_queries", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ReportParamsV2_SearchQuery },
            { no: 12, name: "predicate_filters", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PredicateFilter },
            { no: 13, name: "sort_column_key", kind: "message", T: () => ReportParamsV2_SortColumnKey },
            { no: 15, name: "comparison_ranges", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TimestampRange },
            { no: 16, name: "show_date_compared_percent_change", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 17, name: "show_date_compared_delta", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 19, name: "sorts", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ReportParamsV2_Sort },
            { no: 18, name: "client_timezone", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ReportParamsV2>): ReportParamsV2 {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.baseData = 0;
        message.columns = [];
        message.sortColumnIndex = 0;
        message.sortOrder = 0;
        message.filters = [];
        message.unaggregated = false;
        message.searchQueries = [];
        message.predicateFilters = [];
        message.comparisonRanges = [];
        message.showDateComparedPercentChange = false;
        message.showDateComparedDelta = false;
        message.sorts = [];
        message.clientTimezone = "";
        if (value !== undefined)
            reflectionMergePartial<ReportParamsV2>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReportParamsV2): ReportParamsV2 {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analyticsv2.reportbuilder.BaseData base_data */ 1:
                    message.baseData = reader.int32();
                    break;
                case /* rd.proto.timestamprange.TimestampRange data_source_range */ 2:
                    message.dataSourceRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.dataSourceRange);
                    break;
                case /* repeated rd.analyticsv2.reportbuilder.ReportParamsV2.Column columns */ 3:
                    message.columns.push(ReportParamsV2_Column.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 sort_column_index */ 6:
                    message.sortColumnIndex = reader.int32();
                    break;
                case /* int32 sort_order */ 7:
                    message.sortOrder = reader.int32();
                    break;
                case /* repeated rd.analyticsv2.reportbuilder.Filter filters */ 8:
                    message.filters.push(Filter.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool unaggregated */ 9:
                    message.unaggregated = reader.bool();
                    break;
                case /* repeated rd.analyticsv2.reportbuilder.ReportParamsV2.SearchQuery search_queries */ 10:
                    message.searchQueries.push(ReportParamsV2_SearchQuery.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.analyticsv2.reportbuilder.PredicateFilter predicate_filters */ 12:
                    message.predicateFilters.push(PredicateFilter.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.analyticsv2.reportbuilder.ReportParamsV2.SortColumnKey sort_column_key */ 13:
                    message.sortColumnKey = ReportParamsV2_SortColumnKey.internalBinaryRead(reader, reader.uint32(), options, message.sortColumnKey);
                    break;
                case /* repeated rd.proto.timestamprange.TimestampRange comparison_ranges */ 15:
                    message.comparisonRanges.push(TimestampRange.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* bool show_date_compared_percent_change */ 16:
                    message.showDateComparedPercentChange = reader.bool();
                    break;
                case /* bool show_date_compared_delta */ 17:
                    message.showDateComparedDelta = reader.bool();
                    break;
                case /* repeated rd.analyticsv2.reportbuilder.ReportParamsV2.Sort sorts */ 19:
                    message.sorts.push(ReportParamsV2_Sort.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string client_timezone */ 18:
                    message.clientTimezone = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReportParamsV2, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analyticsv2.reportbuilder.BaseData base_data = 1; */
        if (message.baseData !== 0)
            writer.tag(1, WireType.Varint).int32(message.baseData);
        /* rd.proto.timestamprange.TimestampRange data_source_range = 2; */
        if (message.dataSourceRange)
            TimestampRange.internalBinaryWrite(message.dataSourceRange, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.analyticsv2.reportbuilder.ReportParamsV2.Column columns = 3; */
        for (let i = 0; i < message.columns.length; i++)
            ReportParamsV2_Column.internalBinaryWrite(message.columns[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* int32 sort_column_index = 6; */
        if (message.sortColumnIndex !== 0)
            writer.tag(6, WireType.Varint).int32(message.sortColumnIndex);
        /* int32 sort_order = 7; */
        if (message.sortOrder !== 0)
            writer.tag(7, WireType.Varint).int32(message.sortOrder);
        /* repeated rd.analyticsv2.reportbuilder.Filter filters = 8; */
        for (let i = 0; i < message.filters.length; i++)
            Filter.internalBinaryWrite(message.filters[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* bool unaggregated = 9; */
        if (message.unaggregated !== false)
            writer.tag(9, WireType.Varint).bool(message.unaggregated);
        /* repeated rd.analyticsv2.reportbuilder.ReportParamsV2.SearchQuery search_queries = 10; */
        for (let i = 0; i < message.searchQueries.length; i++)
            ReportParamsV2_SearchQuery.internalBinaryWrite(message.searchQueries[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.analyticsv2.reportbuilder.PredicateFilter predicate_filters = 12; */
        for (let i = 0; i < message.predicateFilters.length; i++)
            PredicateFilter.internalBinaryWrite(message.predicateFilters[i], writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* rd.analyticsv2.reportbuilder.ReportParamsV2.SortColumnKey sort_column_key = 13; */
        if (message.sortColumnKey)
            ReportParamsV2_SortColumnKey.internalBinaryWrite(message.sortColumnKey, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.timestamprange.TimestampRange comparison_ranges = 15; */
        for (let i = 0; i < message.comparisonRanges.length; i++)
            TimestampRange.internalBinaryWrite(message.comparisonRanges[i], writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* bool show_date_compared_percent_change = 16; */
        if (message.showDateComparedPercentChange !== false)
            writer.tag(16, WireType.Varint).bool(message.showDateComparedPercentChange);
        /* bool show_date_compared_delta = 17; */
        if (message.showDateComparedDelta !== false)
            writer.tag(17, WireType.Varint).bool(message.showDateComparedDelta);
        /* string client_timezone = 18; */
        if (message.clientTimezone !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.clientTimezone);
        /* repeated rd.analyticsv2.reportbuilder.ReportParamsV2.Sort sorts = 19; */
        for (let i = 0; i < message.sorts.length; i++)
            ReportParamsV2_Sort.internalBinaryWrite(message.sorts[i], writer.tag(19, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.analyticsv2.reportbuilder.ReportParamsV2
 */
export const ReportParamsV2 = new ReportParamsV2$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReportParamsV2_Column$Type extends MessageType<ReportParamsV2_Column> {
    constructor() {
        super("rd.analyticsv2.reportbuilder.ReportParamsV2.Column", [
            { no: 1, name: "group", kind: "enum", T: () => ["rd.analyticsv2.reportbuilder.GroupV2", GroupV2] },
            { no: 2, name: "subgroups", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.analyticsv2.reportbuilder.GroupV2", GroupV2] },
            { no: 3, name: "aggregation", kind: "enum", T: () => ["rd.analyticsv2.reportbuilder.Aggregation", Aggregation, "AGGREGATION_"] },
            { no: 4, name: "time_format", kind: "enum", T: () => ["rd.analyticsv2.reportbuilder.GroupV2", GroupV2] },
            { no: 5, name: "summary_aggregation", kind: "enum", T: () => ["rd.analyticsv2.reportbuilder.Aggregation", Aggregation, "AGGREGATION_"] },
            { no: 6, name: "is_non_aggregating", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "is_date_compared", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "is_summary_card_hidden", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<ReportParamsV2_Column>): ReportParamsV2_Column {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.group = 0;
        message.subgroups = [];
        message.aggregation = 0;
        message.timeFormat = 0;
        message.summaryAggregation = 0;
        message.isNonAggregating = false;
        message.isDateCompared = false;
        message.isSummaryCardHidden = false;
        if (value !== undefined)
            reflectionMergePartial<ReportParamsV2_Column>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReportParamsV2_Column): ReportParamsV2_Column {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analyticsv2.reportbuilder.GroupV2 group */ 1:
                    message.group = reader.int32();
                    break;
                case /* repeated rd.analyticsv2.reportbuilder.GroupV2 subgroups */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.subgroups.push(reader.int32());
                    else
                        message.subgroups.push(reader.int32());
                    break;
                case /* rd.analyticsv2.reportbuilder.Aggregation aggregation */ 3:
                    message.aggregation = reader.int32();
                    break;
                case /* rd.analyticsv2.reportbuilder.GroupV2 time_format */ 4:
                    message.timeFormat = reader.int32();
                    break;
                case /* rd.analyticsv2.reportbuilder.Aggregation summary_aggregation */ 5:
                    message.summaryAggregation = reader.int32();
                    break;
                case /* bool is_non_aggregating */ 6:
                    message.isNonAggregating = reader.bool();
                    break;
                case /* bool is_date_compared */ 7:
                    message.isDateCompared = reader.bool();
                    break;
                case /* bool is_summary_card_hidden */ 8:
                    message.isSummaryCardHidden = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReportParamsV2_Column, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analyticsv2.reportbuilder.GroupV2 group = 1; */
        if (message.group !== 0)
            writer.tag(1, WireType.Varint).int32(message.group);
        /* repeated rd.analyticsv2.reportbuilder.GroupV2 subgroups = 2; */
        if (message.subgroups.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.subgroups.length; i++)
                writer.int32(message.subgroups[i]);
            writer.join();
        }
        /* rd.analyticsv2.reportbuilder.Aggregation aggregation = 3; */
        if (message.aggregation !== 0)
            writer.tag(3, WireType.Varint).int32(message.aggregation);
        /* rd.analyticsv2.reportbuilder.GroupV2 time_format = 4; */
        if (message.timeFormat !== 0)
            writer.tag(4, WireType.Varint).int32(message.timeFormat);
        /* rd.analyticsv2.reportbuilder.Aggregation summary_aggregation = 5; */
        if (message.summaryAggregation !== 0)
            writer.tag(5, WireType.Varint).int32(message.summaryAggregation);
        /* bool is_non_aggregating = 6; */
        if (message.isNonAggregating !== false)
            writer.tag(6, WireType.Varint).bool(message.isNonAggregating);
        /* bool is_date_compared = 7; */
        if (message.isDateCompared !== false)
            writer.tag(7, WireType.Varint).bool(message.isDateCompared);
        /* bool is_summary_card_hidden = 8; */
        if (message.isSummaryCardHidden !== false)
            writer.tag(8, WireType.Varint).bool(message.isSummaryCardHidden);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.analyticsv2.reportbuilder.ReportParamsV2.Column
 */
export const ReportParamsV2_Column = new ReportParamsV2_Column$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReportParamsV2_SearchQuery$Type extends MessageType<ReportParamsV2_SearchQuery> {
    constructor() {
        super("rd.analyticsv2.reportbuilder.ReportParamsV2.SearchQuery", [
            { no: 1, name: "query_type", kind: "enum", T: () => ["rd.analyticsv2.reportbuilder.ReportParamsV2.SearchQuery.QueryType", ReportParamsV2_SearchQuery_QueryType, "QUERY_TYPE_"] },
            { no: 2, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ReportParamsV2_SearchQuery>): ReportParamsV2_SearchQuery {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.queryType = 0;
        message.query = "";
        if (value !== undefined)
            reflectionMergePartial<ReportParamsV2_SearchQuery>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReportParamsV2_SearchQuery): ReportParamsV2_SearchQuery {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analyticsv2.reportbuilder.ReportParamsV2.SearchQuery.QueryType query_type */ 1:
                    message.queryType = reader.int32();
                    break;
                case /* string query */ 2:
                    message.query = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReportParamsV2_SearchQuery, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analyticsv2.reportbuilder.ReportParamsV2.SearchQuery.QueryType query_type = 1; */
        if (message.queryType !== 0)
            writer.tag(1, WireType.Varint).int32(message.queryType);
        /* string query = 2; */
        if (message.query !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.query);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.analyticsv2.reportbuilder.ReportParamsV2.SearchQuery
 */
export const ReportParamsV2_SearchQuery = new ReportParamsV2_SearchQuery$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReportParamsV2_DateCompareColumnKey$Type extends MessageType<ReportParamsV2_DateCompareColumnKey> {
    constructor() {
        super("rd.analyticsv2.reportbuilder.ReportParamsV2.DateCompareColumnKey", [
            { no: 1, name: "dc_range", kind: "message", T: () => TimestampRange },
            { no: 2, name: "dc_column_type", kind: "enum", T: () => ["rd.analyticsv2.reportbuilder.ReportParamsV2.DateCompareColumnKey.DateCompareColumnType", ReportParamsV2_DateCompareColumnKey_DateCompareColumnType] }
        ]);
    }
    create(value?: PartialMessage<ReportParamsV2_DateCompareColumnKey>): ReportParamsV2_DateCompareColumnKey {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.dcColumnType = 0;
        if (value !== undefined)
            reflectionMergePartial<ReportParamsV2_DateCompareColumnKey>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReportParamsV2_DateCompareColumnKey): ReportParamsV2_DateCompareColumnKey {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.timestamprange.TimestampRange dc_range */ 1:
                    message.dcRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.dcRange);
                    break;
                case /* rd.analyticsv2.reportbuilder.ReportParamsV2.DateCompareColumnKey.DateCompareColumnType dc_column_type */ 2:
                    message.dcColumnType = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReportParamsV2_DateCompareColumnKey, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.timestamprange.TimestampRange dc_range = 1; */
        if (message.dcRange)
            TimestampRange.internalBinaryWrite(message.dcRange, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.analyticsv2.reportbuilder.ReportParamsV2.DateCompareColumnKey.DateCompareColumnType dc_column_type = 2; */
        if (message.dcColumnType !== 0)
            writer.tag(2, WireType.Varint).int32(message.dcColumnType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.analyticsv2.reportbuilder.ReportParamsV2.DateCompareColumnKey
 */
export const ReportParamsV2_DateCompareColumnKey = new ReportParamsV2_DateCompareColumnKey$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReportParamsV2_SortColumnKey$Type extends MessageType<ReportParamsV2_SortColumnKey> {
    constructor() {
        super("rd.analyticsv2.reportbuilder.ReportParamsV2.SortColumnKey", [
            { no: 1, name: "group", kind: "enum", T: () => ["rd.analyticsv2.reportbuilder.GroupV2", GroupV2] },
            { no: 2, name: "subgroupValues", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "dc_key", kind: "message", T: () => ReportParamsV2_DateCompareColumnKey }
        ]);
    }
    create(value?: PartialMessage<ReportParamsV2_SortColumnKey>): ReportParamsV2_SortColumnKey {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.group = 0;
        message.subgroupValues = [];
        if (value !== undefined)
            reflectionMergePartial<ReportParamsV2_SortColumnKey>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReportParamsV2_SortColumnKey): ReportParamsV2_SortColumnKey {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analyticsv2.reportbuilder.GroupV2 group */ 1:
                    message.group = reader.int32();
                    break;
                case /* repeated string subgroupValues */ 2:
                    message.subgroupValues.push(reader.string());
                    break;
                case /* rd.analyticsv2.reportbuilder.ReportParamsV2.DateCompareColumnKey dc_key */ 3:
                    message.dcKey = ReportParamsV2_DateCompareColumnKey.internalBinaryRead(reader, reader.uint32(), options, message.dcKey);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReportParamsV2_SortColumnKey, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analyticsv2.reportbuilder.GroupV2 group = 1; */
        if (message.group !== 0)
            writer.tag(1, WireType.Varint).int32(message.group);
        /* repeated string subgroupValues = 2; */
        for (let i = 0; i < message.subgroupValues.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.subgroupValues[i]);
        /* rd.analyticsv2.reportbuilder.ReportParamsV2.DateCompareColumnKey dc_key = 3; */
        if (message.dcKey)
            ReportParamsV2_DateCompareColumnKey.internalBinaryWrite(message.dcKey, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.analyticsv2.reportbuilder.ReportParamsV2.SortColumnKey
 */
export const ReportParamsV2_SortColumnKey = new ReportParamsV2_SortColumnKey$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReportParamsV2_Sort$Type extends MessageType<ReportParamsV2_Sort> {
    constructor() {
        super("rd.analyticsv2.reportbuilder.ReportParamsV2.Sort", [
            { no: 1, name: "column_key", kind: "message", T: () => ReportParamsV2_SortColumnKey },
            { no: 2, name: "order", kind: "enum", T: () => ["rd.analyticsv2.SortOrder", SortOrder, "SORT_ORDER_"] }
        ]);
    }
    create(value?: PartialMessage<ReportParamsV2_Sort>): ReportParamsV2_Sort {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.order = 0;
        if (value !== undefined)
            reflectionMergePartial<ReportParamsV2_Sort>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ReportParamsV2_Sort): ReportParamsV2_Sort {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analyticsv2.reportbuilder.ReportParamsV2.SortColumnKey column_key */ 1:
                    message.columnKey = ReportParamsV2_SortColumnKey.internalBinaryRead(reader, reader.uint32(), options, message.columnKey);
                    break;
                case /* rd.analyticsv2.SortOrder order */ 2:
                    message.order = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ReportParamsV2_Sort, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analyticsv2.reportbuilder.ReportParamsV2.SortColumnKey column_key = 1; */
        if (message.columnKey)
            ReportParamsV2_SortColumnKey.internalBinaryWrite(message.columnKey, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.analyticsv2.SortOrder order = 2; */
        if (message.order !== 0)
            writer.tag(2, WireType.Varint).int32(message.order);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.analyticsv2.reportbuilder.ReportParamsV2.Sort
 */
export const ReportParamsV2_Sort = new ReportParamsV2_Sort$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ColumnOption$Type extends MessageType<ColumnOption> {
    constructor() {
        super("rd.analyticsv2.reportbuilder.ColumnOption", [
            { no: 1, name: "group", kind: "enum", T: () => ["rd.analyticsv2.reportbuilder.GroupV2", GroupV2] },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ColumnOption>): ColumnOption {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.group = 0;
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial<ColumnOption>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ColumnOption): ColumnOption {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.analyticsv2.reportbuilder.GroupV2 group */ 1:
                    message.group = reader.int32();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ColumnOption, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.analyticsv2.reportbuilder.GroupV2 group = 1; */
        if (message.group !== 0)
            writer.tag(1, WireType.Varint).int32(message.group);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.analyticsv2.reportbuilder.ColumnOption
 */
export const ColumnOption = new ColumnOption$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SavedReport$Type extends MessageType<SavedReport> {
    constructor() {
        super("rd.analyticsv2.reportbuilder.SavedReport", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "company_id", kind: "message", T: () => UUID },
            { no: 5, name: "created_by", kind: "message", T: () => User },
            { no: 6, name: "updated_by", kind: "message", T: () => User },
            { no: 7, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 8, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 9, name: "params", kind: "message", T: () => ReportParamsV2 },
            { no: 10, name: "is_global", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "column_widths", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 5 /*ScalarType.INT32*/ } }
        ]);
    }
    create(value?: PartialMessage<SavedReport>): SavedReport {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.identifier = "";
        message.name = "";
        message.isGlobal = false;
        message.columnWidths = {};
        if (value !== undefined)
            reflectionMergePartial<SavedReport>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SavedReport): SavedReport {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* string identifier */ 2:
                    message.identifier = reader.string();
                    break;
                case /* string name */ 3:
                    message.name = reader.string();
                    break;
                case /* rd.proto.uuid.UUID company_id */ 4:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.user.User created_by */ 5:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* rd.user.User updated_by */ 6:
                    message.updatedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.updatedBy);
                    break;
                case /* google.protobuf.Timestamp created_at */ 7:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 8:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.analyticsv2.reportbuilder.ReportParamsV2 params */ 9:
                    message.params = ReportParamsV2.internalBinaryRead(reader, reader.uint32(), options, message.params);
                    break;
                case /* bool is_global */ 10:
                    message.isGlobal = reader.bool();
                    break;
                case /* map<string, int32> column_widths */ 11:
                    this.binaryReadMap11(message.columnWidths, reader, options);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap11(map: SavedReport["columnWidths"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof SavedReport["columnWidths"] | undefined, val: SavedReport["columnWidths"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = reader.int32();
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.analyticsv2.reportbuilder.SavedReport.column_widths");
            }
        }
        map[key ?? ""] = val ?? 0;
    }
    internalBinaryWrite(message: SavedReport, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string identifier = 2; */
        if (message.identifier !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.identifier);
        /* string name = 3; */
        if (message.name !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.name);
        /* rd.proto.uuid.UUID company_id = 4; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 5; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User updated_by = 6; */
        if (message.updatedBy)
            User.internalBinaryWrite(message.updatedBy, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 7; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 8; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.analyticsv2.reportbuilder.ReportParamsV2 params = 9; */
        if (message.params)
            ReportParamsV2.internalBinaryWrite(message.params, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* bool is_global = 10; */
        if (message.isGlobal !== false)
            writer.tag(10, WireType.Varint).bool(message.isGlobal);
        /* map<string, int32> column_widths = 11; */
        for (let k of globalThis.Object.keys(message.columnWidths))
            writer.tag(11, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k).tag(2, WireType.Varint).int32(message.columnWidths[k]).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.analyticsv2.reportbuilder.SavedReport
 */
export const SavedReport = new SavedReport$Type();
